(function () {
  'use strict';
  if (window.__bncRuntime) return;          // sections may reference this once each
  window.__bncRuntime = true;

  /* Sizing pass for marquee tracks: duration scales with content width so a
     long row is not whipped across the screen. */
  /* Press strip: one copy per loop at the marquee pace.

     The list renders its blocks twice and the keyframe translates -50%, so the
     distance travelled per cycle is one copy width. Duration therefore has to
     come from the measured copy, not a constant: the items are min(70vw,260px)
     wide, so a 320px phone and a 430px phone have different copy widths and a
     fixed duration would run them at different speeds.

     18px/sec is the testimonial strip's MEASURED pace, which is half what its
     own code reads as: initMarqueeTracks derives duration as width/36, but its
     keyframe travels 50% of the width, so the strip covers width/2 in that
     time and moves at 18px/sec on screen. Matching the formula rather than the
     movement ran this strip at double speed beside it. */
  function initPressMarquee() {
    $$('[data-bn-press-marquee]').forEach(function (list) {
      var apply = function () {
        var half = list.scrollWidth / 2;
        if (!(half > 0)) return;
        list.style.setProperty('--bn-press-dur', Math.max(12, Math.round(half / 18)) + 's');
      };
      apply();
      if (list.__bnPressRO || !window.ResizeObserver) return;
      /* Item width is viewport-relative, so the copy width changes on rotation
         and the duration has to be recomputed or the pace drifts. */
      list.__bnPressRO = new ResizeObserver(function () { apply(); });
      list.__bnPressRO.observe(list);
    });
  }

  /* Mark carousels whose content already fits, so the stylesheet can withhold
     the arrows. A visible arrow that cannot move anything reads as broken, and
     which tracks overflow changes with the breakpoint - IN THE BOX scrolls at
     two-up on a phone and fits at three-up on a desktop - so this is recomputed
     rather than decided once. */
  function initArrowVisibility() {
    $$('.gem-slider.bn-track').forEach(function (t) {
      var scope = t.closest('[class*="bnc-group/carousel"]') || t.parentElement;
      if (!scope) return;
      var fits = (t.scrollWidth - t.clientWidth) < 8;
      scope.classList.toggle('bn-noscroll', fits);
    });
  }

  function initMarqueeTracks() {
    $$('.rfm-marquee-container').forEach(function (c) {
      if (c.__bncMq) return; c.__bncMq = true;
      var w = c.scrollWidth || 2000;
      // ~60px/sec, then slowed 40% per the agreed pacing
      c.style.setProperty('--bnc-mq-duration', Math.max(24, Math.round((w / 60) / 0.6)) + 's');
    });
  }

/* Basis — native runtime for compiled sections.
 *
 * The compiled sections are plain HTML/CSS: layout, spacing, type and colour
 * all resolve from the stylesheet with no script running. This file adds only
 * behaviour, so with JavaScript disabled every section still renders its
 * content. That is the property the previous vendor architecture lacked, where
 * content shipped hidden and was revealed by the runtime.
 *
 * Elements are marked at compile time with data-bn-role.
 */

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------------- *
   * Lazy media. Loads on approach, with an unconditional backstop:
   * an IntersectionObserver alone leaves media unloaded inside
   * content-visibility subtrees and on fast scrolls.
   * ---------------------------------------------------------------- */
  function isGalleryVideo(el) {
    return el && el.tagName === 'VIDEO' &&
      !!el.closest('.bn-pm__stage, .gem-slider, [data-bn-carousel], [id^="bnc-carousel-"]');
  }

  function swapMedia(el) {
    /* Gallery videos are owned by initGalleryAutoplay. Both initLazy and
       loadRemaining used to route through here, and loadRemaining re-armed them
       on load - which set src, tripped the autoplay attribute and pulled the
       whole file down for a slide nobody had reached. One guard, not two
       filters. */
    /* Skip gallery videos that do NOT ask for autoplay - those are tap-to-play
       and must not be armed here (that is what pulled a 34MB master down for a
       slide nobody had reached). A gallery video that DOES carry `autoplay` is
       authored like the hero videos that work on a handset, so let it through
       and load normally. */
    if (isGalleryVideo(el) && !el.hasAttribute('autoplay')) return;
    if (el.hasAttribute('data-bnc-loaded')) return;
    var src = el.getAttribute('data-src');
    var set = el.getAttribute('data-srcset');
    if (set) el.setAttribute('srcset', set);
    if (src) el.setAttribute('src', src);
    el.setAttribute('data-bnc-loaded', '');
    if (el.tagName === 'VIDEO') {
      el.playsInline = true;
      var dp = el.getAttribute('data-poster');
      if (dp && !el.getAttribute('poster')) el.setAttribute('poster', dp);
      /* Only autoplay what was authored to autoplay. This used to force play()
         on EVERY lazy video and strip its controls, which meant the product
         gallery's 1080p/7.2Mbps clip - authored with `controls` and no
         `autoplay` - was played on load and pulled ~30MB of range requests on a
         phone before the buyer touched anything. Decorative background loops
         still carry `autoplay` in their markup and are unaffected, so the hero
         keeps playing by itself. A video the author gave controls to is a video
         the visitor is meant to start. */
      var wantsAuto = el.hasAttribute('autoplay') ||
                      el.getAttribute('data-bn-autoplay') === '1';
      if (!wantsAuto) return;
      el.muted = true; el.removeAttribute('controls');
      /* Re-assert loop on the element itself. The attribute is authored on some
         of the responsive variants and not others, so a background video could
         play once and stop. Setting the property covers every variant. */
      el.loop = true;
      /* Playback is owned by initVideoVisibility, not here. This used to call
         play() immediately and again on `canplay`, which raced the visibility
         gate: the gate paused an off-screen clip and the canplay handler
         restarted it. Measured against the live theme, that pulled 48MB of
         video on the homepage that live never downloads at all. Leave it
         paused; the gate starts it the moment it is actually on screen. */
      el.preload = 'metadata';
    }
  }
  function initLazy() {
    var t = $$('[data-src]:not([data-bnc-loaded]),[data-srcset]:not([data-bnc-loaded])');
    if (!t.length) return;
    if (!('IntersectionObserver' in window)) { t.forEach(swapMedia); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { swapMedia(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '400px 0px' });
    /* Videos are swapped only when genuinely near the viewport. An image
       fetched early is a few KB; a background video fetched early is megabytes. */
    t.forEach(function (el) { io.observe(el); });
  }

  /* Play only what is on screen. Autoplaying background videos were started as
     soon as they came within 1200px of the viewport and then ran forever, so a
     phone downloaded and decoded every clip on the page whether or not the
     visitor ever scrolled to it - 56MB on the homepage. Pausing off-screen
     video is invisible to the visitor (a paused off-screen loop looks identical
     when they arrive, and resumes on entry) and costs nothing in conversion.
     Only ever touches videos that were authored to autoplay; a video the
     visitor started themselves is left alone. */
  /* Gallery video plays when its slide LANDS, not when enough of it happens to
     be down the page. The first cut gated on vertical intersection ratio, which
     is the wrong axis: a carousel slide becomes active by scrolling the track
     sideways, and the gallery often sits half-way up the viewport where a 0.6
     ratio never trips. Condition is: the track is meaningfully on screen AND
     this video's slide covers the track's horizontal centre.

     Still no `autoplay` attribute and still `preload="none"`, so nothing
     downloads until the visitor actually reaches the slide. */
  /* On-device video probe: append ?bnvideo=1 to any URL.
     Exists because this environment cannot test autoplay at all - a desktop
     WebKit build with isMobile:true has no autoplay policy, so a scripted
     play() always resolves there and always looked "verified" while a real
     handset refused it. The only sound instrument is the actual phone. */
  function initVideoProbe() {
    if (location.search.indexOf('bnvideo=1') === -1) return;
    function scan() {
      var rows = [];
      $$('video').forEach(function (v, i) {
        var r = v.getBoundingClientRect();
        rows.push(
          '#' + i + ' ' + (v.className || '').toString().split(' ')[0].slice(0, 14) +
          '\n   attrs: muted=' + v.hasAttribute('muted') +
          ' autoplay=' + v.hasAttribute('autoplay') +
          ' playsinline=' + v.hasAttribute('playsinline') +
          '\n   prop muted=' + v.muted + '  armed=' + !!v.__bnArmed +
          '  src=' + (v.getAttribute('src') ? 'set' : 'none') +
          '\n   paused=' + v.paused + ' readyState=' + v.readyState +
          ' t=' + v.currentTime.toFixed(1) +
          '\n   err=' + (v.error ? v.error.code : '-') +
          ' onScreen=' + (r.top < innerHeight && r.bottom > 0));
      });
      var box = document.getElementById('bn-vid') || document.createElement('div');
      box.id = 'bn-vid';
      box.style.cssText = 'position:fixed;left:8px;right:8px;bottom:8px;z-index:2147483647;' +
        'background:#111;color:#fff;font:11px/1.4 monospace;padding:10px;' +
        'border-radius:8px;max-height:52vh;overflow:auto;white-space:pre-wrap';
      box.textContent = 'videos: ' + rows.length + '  (lowPower blocks autoplay)\n\n' + rows.join('\n\n');
      if (!box.parentElement) document.body.appendChild(box);
    }
    scan();
    setInterval(scan, 1000);
  }

  /* Run before anything else touches these. The compiled gallery markup ships
     an eager `src` with no muted/autoplay, so iOS classifies it at parse time as
     a video it may not autoplay, and it starts downloading immediately. Move the
     src to data-src (which aborts the fetch) and set the attributes iOS requires
     now, so that assigning src later is all it takes to start playback. */
  function armGalleryVideos() {
    $$('video').forEach(function (v) {
      if (!isGalleryVideo(v) || v.__bnDisarmed) return;
      v.__bnDisarmed = true;
      /* NEVER leave the element without a source. An earlier version stripped
         `src` and restored it only when the landing detector fired; when that
         detector did not fire the video had nothing to play, so even TAPPING
         the play button did nothing. Playback must not depend on my detection
         being right - that is fail-dead. Removing `src` was also unnecessary:
         `preload="none"` already downloads nothing, and it was the `autoplay`
         attribute that pulled the file, not the presence of a source. */
      v.setAttribute('preload', 'none');
      v.removeAttribute('autoplay');     // added back when the slide lands
      if (!v.getAttribute('src')) {
        var ds0 = v.getAttribute('data-src');
        if (ds0) v.setAttribute('src', ds0);
      }
      v.setAttribute('muted', '');       v.muted = true;
      v.setAttribute('playsinline', ''); v.playsInline = true;
    });
  }

  function initGalleryAutoplay() {
    armGalleryVideos();
    var tracks = $$('.bn-pm__stage, .gem-slider, [data-bn-carousel], [id^="bnc-carousel-ft-"]');
    tracks.forEach(function (track) {
      if (track.__bnGA) return;
      if (!track.querySelector('video')) return;
      track.__bnGA = true;

      function sync() {
        var tr = track.getBoundingClientRect();
        if (!tr.height) return;
        var shown = Math.max(0, Math.min(tr.bottom, window.innerHeight) - Math.max(tr.top, 0));
        var onScreen = (shown / tr.height) > 0.25;
        var vids = track.querySelectorAll('video');
        for (var i = 0; i < vids.length; i++) {
          var v = vids[i];
          if (v.__bnUserPlayed) continue;
          var r = v.getBoundingClientRect();
          /* Landed means "this slide is the one being shown", measured as how
             much of the video sits inside the track's own box.

             The previous test asked whether the video straddled the track's
             horizontal centre. That only ever holds for a one-up track. With
             an even number of slides in view the centre falls in the GAP
             between two of them, so nothing straddles it and no video in that
             track ever plays: measured on the control homepage comparison row
             at 375px, track 10-375 with centre 192.5, slides 10-183 and
             203-375, both rejected. Neither loaded its source, and with no
             poster attribute both painted as black boxes - the "section looks
             broken" report. Overlap works for one-up and n-up alike. */
          var visL = Math.max(r.left, tr.left), visR = Math.min(r.right, tr.right);
          var landed = r.width > 0 && ((Math.max(0, visR - visL) / r.width) > 0.6);
          if (onScreen && landed) {
            /* Hand the browser everything it needs and let IT start playback.
               iOS refuses a scripted play() for a video that is not already
               muted+inline BY ATTRIBUTE, which is exactly how the GemPages
               originals that do autoplay are authored. Set the attributes, then
               assign src from data-src; the `autoplay` attribute fires on its
               own. The play() below is only a fallback for engines that want an
               explicit nudge - on iOS the attributes are what actually work. */
            if (!v.__bnArmed) {
              v.__bnArmed = true;
              v.setAttribute('muted', '');      v.muted = true;
              v.setAttribute('playsinline', ''); v.playsInline = true;
              /* src is already present; adding `autoplay` plus the play() below
                 is what starts it. Nothing was downloaded before this point
                 because preload is none. */
              var ds = v.getAttribute('data-src');
              if (ds && !v.getAttribute('src')) v.setAttribute('src', ds);
              v.setAttribute('autoplay', '');
            }
            var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        }
      }
      function debounce(key, ms) {
        return function () { clearTimeout(track[key]); track[key] = setTimeout(sync, ms); };
      }
      track.addEventListener('scroll', debounce('__bnTs', 110), { passive: true });
      window.addEventListener('scroll', debounce('__bnTw', 140), { passive: true });
      window.addEventListener('resize', debounce('__bnTr', 200));
      sync();
      setTimeout(sync, 900);
      setTimeout(sync, 2500);
    });
  }

  function initVideoVisibility() {
    if (!('IntersectionObserver' in window) || window.__bnVidVis) return;
    window.__bnVidVis = true;
    var vo = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (v.__bnUserPlayed) return;
        /* A gallery slide has to be substantially in view before it counts as
           "landed" - a carousel neighbour peeking in by a few pixels is not the
           active slide. Background loops play as soon as any of them shows. */
        var need = v.__bnGallery ? 0.6 : 0;
        var on = e.isIntersecting && e.intersectionRatio > need;
        if (on) {
          if (v.__bnGallery) { v.muted = true; v.playsInline = true; }
          var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '100px 0px', threshold: [0, 0.6, 0.9] });
    function watch() {
      var vids = $$('video');
      for (var i = 0; i < vids.length; i++) {
        var v = vids[i];
        if (v.__bnVisWatched) continue;
        v.__bnVisWatched = true;
        if (!v.hasAttribute('autoplay') && v.getAttribute('data-bn-autoplay') !== '1') {
          /* A video sitting in a gallery/carousel track plays when its slide
             lands, rather than asking for a tap. It keeps `preload="none"` and
             no `autoplay` attribute, so nothing downloads until the visitor
             actually reaches that slide - which is what kept 48MB off the page.
             Controls stay on so they can unmute or scrub. */
          if (v.closest('.bn-pm__stage, .gem-slider, [data-bn-carousel], [id^="bnc-carousel-"]')) {
            /* Owned by initGalleryAutoplay, which triggers on the slide LANDING
               (horizontal position in the track) rather than on how much of the
               video happens to be down the viewport. Not observed here. */
            v.__bnGallery = true;
            v.addEventListener('play', function () {
              if (!this.muted) this.__bnUserPlayed = true;   // real interaction
            });
            continue;
          }
          /* Visitor-controlled video: never auto-pause it once they hit play. */
          v.addEventListener('play', function () { this.__bnUserPlayed = true; });
          continue;
        }
        vo.observe(v);
      }
    }
    watch();
    setTimeout(watch, 1500);
    setTimeout(watch, 4000);
  }
  function loadRemaining() { $$('[data-src]:not([data-bnc-loaded]),[data-srcset]:not([data-bnc-loaded])').forEach(swapMedia); }

  /* ---------------------------------------------------------------- *
   * Carousels — CSS scroll-snap. Touch swipe and trackpad are native;
   * this adds mouse drag, arrows and keyboard.
   * ---------------------------------------------------------------- */
  /* Resolve the builder's real track. It is marked .gem-slider /
     .gem-slider-wrapper - never guess from child counts. The old heuristic
     walked into the product module's GRID, stamped bnc-track on it, and the
     bnc-track rule forced display:flex onto a grid whose 2fr/10fr columns
     position the thumbnail rail and the main image. The rail took 720px instead
     of ~198px and the image was pushed out of frame. */
  function track(host) {
    if (host.classList &&
        (host.classList.contains('gem-slider') ||
         host.classList.contains('gem-slider-wrapper'))) return host;
    return host.querySelector('.gem-slider, .gem-slider-wrapper');
  }
  function initCarousel(host) {
    if (host.__bnc) return;
    var t = track(host);
    if (!t) return;              // no builder track here: not a carousel
    host.__bnc = true;
    t.classList.add('bnc-track');
    var slides = function () { return $$(':scope > *', t); };
    var index = function () {
      var best = 0, d = Infinity;
      slides().forEach(function (s, i) {
        var x = Math.abs(s.offsetLeft - t.offsetLeft - t.scrollLeft);
        if (x < d) { d = x; best = i; }
      });
      return best;
    };
    var go = function (i) {
      var s = slides();
      i = Math.max(0, Math.min(s.length - 1, i));
      if (s[i]) t.scrollTo({ left: s[i].offsetLeft - t.offsetLeft, behavior: 'smooth' });
    };
    // mouse drag (touch is left to the browser, which does it better)
    var down = false, moved = false, x0 = 0, l0 = 0, pid = null;
    t.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button !== 0) return;
      down = true; moved = false; pid = e.pointerId; x0 = e.clientX; l0 = t.scrollLeft;
      t.classList.add('is-grabbing'); t.style.scrollSnapType = 'none';
    });
    t.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pid) return;
      var dx = e.clientX - x0;
      if (!moved && Math.abs(dx) > 4) { moved = true; try { t.setPointerCapture(pid); } catch (x) {} }
      if (!moved) return;
      e.preventDefault(); t.scrollLeft = l0 - dx;
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      t.addEventListener(ev, function () {
        if (!down) return;
        down = false; t.classList.remove('is-grabbing'); t.style.scrollSnapType = '';
        if (pid !== null) { try { t.releasePointerCapture(pid); } catch (x) {} }
        pid = null; if (moved) go(index());
      });
    });
    t.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    // arrows: whatever the builder emitted as prev/next
    var scope = host.closest('[data-bn]') || host;
    /* aria-label is the builder's own contract for arrows. Matching on class
       substrings like "next"/"prev" also catches unrelated utility classes. */
    $$('[aria-label*="Arrow" i]', scope).forEach(function (b) {
      var next = /next|right/i.test(b.className);
      b.addEventListener('click', function (e) { e.preventDefault(); go(index() + (next ? 1 : -1)); });
    });
    t.setAttribute('tabindex', t.getAttribute('tabindex') || '0');
    t.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); go(index() - 1); }
    });
  }

  /* ---------------------------------------------------------------- *
   * Marquee — CSS animation, duplicated track for a seamless loop.
   * ---------------------------------------------------------------- */
  function initMarquee(host) {
    if (host.__bnc) return; host.__bnc = true;
    var row = $('.rfm-marquee, .bnc-marquee-row', host) || host.firstElementChild;
    if (!row) return;
    host.classList.add('bnc-mq');
    var w = row.scrollWidth || 1200;
    row.style.setProperty('--bnc-mq-duration', Math.max(20, w / 70 / 0.6) + 's');
  }

  /* ---------------------------------------------------------------- *
   * Accordion / tabs / dialog
   * ---------------------------------------------------------------- */
  /* Accordion. Exact classes only.
     `[class*="accordion-item"]` also matches `accordion-item_header`,
     `accordion-item_body` and `accordion-item_body-inner` - it selected 105
     elements where 21 are real items, then treated bodies as items and toggled
     `display` on the wrong nodes.
     The builder opens and closes via an inline `grid-template-rows` of 1fr/0fr
     on the body (a grid-collapse), with `overflow:hidden` doing the clipping.
     Drive that same property instead of inventing a display toggle. */
  function initAccordion(host) {
    if (host.__bnc) return; host.__bnc = true;
    $$('.bnc-accordion-item', host).forEach(function (item) {
      if (item.__bnAcc) return;
      var head = item.querySelector(':scope > .bnc-accordion-item_header');
      var body = item.querySelector(':scope > .bnc-accordion-item_body');
      if (!head || !body) return;
      item.__bnAcc = true;

      function isOpen() {
        var v = (body.style.gridTemplateRows || getComputedStyle(body).gridTemplateRows || '');
        return v.indexOf('0fr') === -1 && v !== '0px';
      }
      head.setAttribute('role', 'button');
      head.setAttribute('tabindex', head.getAttribute('tabindex') || '0');
      head.setAttribute('aria-expanded', isOpen() ? 'true' : 'false');

      function toggle() {
        var open = !isOpen();
        /* Suppress the authored transition while applying the value.
           The builder puts `transition: all` on this body, and a
           `grid-template-rows: 0fr -> 1fr` change does not interpolate here -
           the value simply never lands and the panel stays 0px. Measured:
           with `transition:none` the same assignment opens to 310px.
           Applying instantly, then restoring the transition, trades the 500ms
           animation for the panel actually opening. */
        var prev = body.style.transition;
        body.style.transition = 'none';
        body.style.gridTemplateRows = open ? '1fr' : '0fr';
        void body.offsetHeight;                 // force reflow so it sticks
        body.style.transition = prev;
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        item.classList.toggle('bn-is-open', open);
      }
      head.addEventListener('click', function (e) { e.preventDefault(); toggle(); });
      head.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });
  }
  /* Tabs. The builder's structure is a `.bnc-tab-header-list` of <li> and a
     sibling `.bnc-tab-item-container` of panels, with the default index in the
     carousel config as `setting.activeKey`. The previous implementation looked
     for `[class*="tab-title"]` / `[class*="tab-content"]`, selectors that exist
     nowhere in this markup, so it returned early and every tab was inert while
     all four panels rendered stacked on top of each other. Read the builder's
     structure; do not invent selectors for it. */
  function initTabs(host) {
    if (host.__bnc) return;
    var list = host.querySelector('.bnc-tab-header-list');
    var cont = host.querySelector('.bnc-tab-item-container');
    if (!list || !cont) return;
    var labels = [].slice.call(list.children);
    var panes = [].slice.call(cont.children).filter(function (n) {
      return n.tagName !== 'STYLE' && n.tagName !== 'SCRIPT';
    });
    if (labels.length < 2 || panes.length < 2) return;
    host.__bnc = true;

    var start = 0;
    try {
      var raw = host.getAttribute('data-bn-config');
      if (raw) {
        var cfg = JSON.parse(raw);
        var k = cfg && cfg.setting && cfg.setting.activeKey;
        if (k != null && !isNaN(parseInt(k, 10))) start = parseInt(k, 10);
      }
    } catch (e) { /* default 0 */ }
    if (start < 0 || start >= panes.length) start = 0;

    list.setAttribute('role', 'tablist');
    labels.forEach(function (l, i) {
      l.setAttribute('role', 'tab');
      l.setAttribute('tabindex', '0');
      if (panes[i]) {
        var pid = 'bn-tabpanel-' + (host.id || 'x') + '-' + i;
        panes[i].id = panes[i].id || pid;
        panes[i].setAttribute('role', 'tabpanel');
        l.setAttribute('aria-controls', panes[i].id);
      }
    });

    /* The builder encodes the active look in each item's OWN inline custom
       properties: the item at activeKey ships the yellow colour plus a solid
       bottom border, the others ship the grey colour and no border. Its runtime
       swapped those values on change. Capture the two authored variants up
       front and swap them. Do not invent an opacity/border layer here - it only
       fights the section's own inline <style> and half-applies. */
    var VARS = ['\u002d\u002dc', '\u002d\u002dbs', '\u002d\u002dbw',
                '\u002d\u002dbc', '\u002d\u002dop'];
    function capture(el) {
      var o = {};
      VARS.forEach(function (v) { o[v] = el.style.getPropertyValue(v); });
      return o;
    }
    function apply(el, vars) {
      VARS.forEach(function (v) {
        if (vars[v]) el.style.setProperty(v, vars[v]);
        else el.style.removeProperty(v);
      });
    }
    var activeVars = capture(labels[start] || labels[0]);
    var idleSrc = labels.filter(function (l, n) { return n !== start; })[0];
    var idleVars = idleSrc ? capture(idleSrc) : {};

    /* Read the authored layout positions rather than assuming them: the pane
       that ships in flow tells us the in-flow value, any other pane the
       stacked value. */
    var flowPos = getComputedStyle(panes[start] || panes[0]).position || 'relative';
    var stackSrc = panes.filter(function (p, n) { return n !== start; })[0];
    var stackPos = stackSrc ? (getComputedStyle(stackSrc).position || 'absolute') : 'absolute';
    if (flowPos === stackPos) { flowPos = 'relative'; stackPos = 'absolute'; }

    /* The builder authors the default pane `position: relative` so it holds the
       container's height, and every other pane `position: absolute` so they
       stack behind it. Its runtime swapped that on switch. Toggling only
       `hidden` meant any newly active pane stayed absolute, the container
       collapsed to 0, and the panel painted on top of the section below.
       Swap position alongside visibility. */
    function select(i) {
      labels.forEach(function (l, n) {
        var on = n === i;
        l.classList.toggle('bn-is-active', on);
        l.setAttribute('aria-selected', on ? 'true' : 'false');
        apply(l, on ? activeVars : idleVars);
      });
      panes.forEach(function (p, n) {
        var on = n === i;
        p.hidden = !on;
        p.style.display = on ? '' : 'none';
        p.style.setProperty('position', on ? flowPos : stackPos, 'important');
      });
    }

    labels.forEach(function (l, i) {
      l.addEventListener('click', function (e) { e.preventDefault(); select(i); });
      l.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(i); }
        else if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + labels.length) % labels.length;
          labels[n].focus(); select(n);
        }
      });
    });
    select(start);
  }
  function initDialog(host) {
    if (host.__bnc) return; host.__bnc = true;
    host.style.display = host.style.display || 'none';
    var id = host.id;
    if (id) {
      $$('[href="#' + id + '"],[data-bnc-open="' + id + '"]').forEach(function (o) {
        o.addEventListener('click', function (e) { e.preventDefault(); host.style.display = 'block'; });
      });
    }
    /* Named close controls only. `[class*="close"]` matched 14 unrelated
       elements on a page with no dialogs at all. */
    $$('[data-bn-close],[aria-label*="close" i],.bnc-dialog-close', host).forEach(function (c) {
      c.addEventListener('click', function (e) { e.preventDefault(); host.style.display = 'none'; });
    });
  }

  /* ---------------------------------------------------------------- *
   * YouTube facades — thumbnail until clicked, then the player.
   * ---------------------------------------------------------------- */
  function initYouTube(host) {
    if (host.__bnc) return; host.__bnc = true;
    var id = host.getAttribute('videoid') || host.getAttribute('data-videoid') ||
             (host.innerHTML.match(/[?&/](?:v=|embed\/)([A-Za-z0-9_-]{11})/) || [])[1];
    if (!id) return;
    host.style.cursor = 'pointer';
    host.addEventListener('click', function () {
      if (host.__played) return; host.__played = true;
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      f.title = 'Video'; f.loading = 'lazy';
      f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      f.setAttribute('allowfullscreen', '');
      f.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0';
      host.style.position = host.style.position || 'relative';
      host.innerHTML = ''; host.appendChild(f);
    });
  }

  /* ---------------------------------------------------------------- *
   * Add to cart. Routed through the theme's own addToCartAjax where it
   * exists, so the cart drawer, its events and any listeners bound to
   * them keep working exactly as they do elsewhere on the site.
   * ---------------------------------------------------------------- */
  function initATC(host) {
    if (host.__bnc) return; host.__bnc = true;
    var btn = $('button,[role="button"],a', host) || host;
    btn.addEventListener('click', function (e) {
      var form = host.closest('form[action*="/cart/add"]');
      var id = (form && form.querySelector('[name="id"]')) ||
               $('[name="id"]', host) || $('[data-variant-id]', host);
      var vid = id ? (id.value || id.getAttribute('data-variant-id')) : host.getAttribute('data-variant-id');
      if (!vid) return;                       // real form present: let it submit
      e.preventDefault();
      var fd = new FormData();
      fd.append('id', vid); fd.append('quantity', 1);
      if (typeof window.addToCartAjax === 'function') { window.addToCartAjax(fd, btn); return; }
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:open'));
        });
    });
  }

  /* data-bn-role="video" had NO handler in ROLES, so the builder's poster
     overlay was left orphaned by the migration. It is an absolutely positioned,
     full-size div (.bnc-thumbnail-video) with pointer-events:auto sitting
     directly on top of the <video>: it swallowed every tap, nothing was bound to
     it, and it hid the video even while the video was playing underneath. That
     is the "there is a play icon but clicking does nothing" report - and why the
     clip appeared dead whether it autoplayed or not.

     GemPages' runtime removed this overlay on playback. Restore that: let taps
     through, start the video if a visitor does tap, and drop the overlay as soon
     as playback begins. */
  function initVideoEmbed(host) {
    if (host.__bnVE) return;
    host.__bnVE = true;
    var v = host.querySelector('video');
    if (!v) return;
    var thumb = host.querySelector('.bnc-thumbnail-video');

    function reveal() {
      if (thumb) thumb.style.display = 'none';
    }
    if (thumb) {
      /* Never let it block the video underneath. */
      thumb.style.pointerEvents = 'none';
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      });
    }
    v.addEventListener('playing', reveal);
    v.addEventListener('timeupdate', function () {
      if (v.currentTime > 0.05) reveal();
    });
    /* Tapping the video itself toggles, for the tap-to-play galleries. */
    host.addEventListener('click', function () {
      if (v.paused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
    });
    if (!v.paused && v.currentTime > 0) reveal();
  }

  var ROLES = {
    carousel: initCarousel, marquee: initMarquee, accordion: initAccordion,
    tab: initTabs, dialog: initDialog, youtube: initYouTube, atc: initATC,
    video: initVideoEmbed
  };


  /* ---------------------------------------------------------------- *
   * Builder slider tracks: native swipe + drag + optional autoplay.
   * The track is already a scroll-snap container in CSS, so touch swipe
   * and trackpad work with no JS. This adds mouse drag, which browsers
   * do not provide, and a slow auto-advance that yields to the reader.
   * ---------------------------------------------------------------- */
  var AUTOPLAY_MS = 3000;

  /* Slides-per-view comes from the carousel's own authored config, which the
     builder stores as `setting.itemNumber` (and the gap as `setting.spacing`).
     The product gallery is {desktop:1}; its thumbnail strip is
     {desktop:'auto', tablet:5, mobile:5}. Sizing slides from that config is what
     the vendor runtime did. A blanket flex rule instead is why the first slide
     sat half out of frame and the video row ran off the edge. */
  function authoredConfig(t) {
    // Walk up until a config that actually describes a carousel. Rows carry
    // their own data-bn-config for background/spacing, so taking the nearest
    // one finds an object with no itemNumber and sizing silently no-ops - which
    // is how a four-across video row kept rendering at desktop widths on mobile.
    var host = t;
    for (var i = 0; i < 10 && host; i++) {
      var raw = host.getAttribute && host.getAttribute('data-bn-config');
      if (raw) {
        try {
          var c = JSON.parse(raw);
          if (c && c.setting && c.setting.itemNumber != null) return c;
        } catch (e) { /* keep walking */ }
      }
      host = host.parentElement;
    }
    return null;
  }
  function bpValue(obj, fallback) {
    if (obj == null) return fallback;
    if (typeof obj !== 'object') return obj;
    var w = document.documentElement.clientWidth;
    var k = w < 768 ? 'mobile' : (w < 1024 ? 'tablet' : 'desktop');
    if (obj[k] != null) return obj[k];
    if (obj.desktop != null) return obj.desktop;
    return fallback;
  }

  /* Size every slide to (track - gaps) / itemNumber, in pixels. Explicit widths
     remove the circular `width:100%` against a content-sized track, which is
     what made slide widths - and therefore snap positions - wrong. */
  function sizeSlides(t) {
    var cfg = authoredConfig(t);
    var st = (cfg && cfg.setting) || cfg || {};
    var raw = bpValue(st.itemNumber, 1);
    if (raw === 'auto') return;            // intrinsic widths: leave alone
    var per = parseFloat(raw) || 1;
    var gap = parseFloat(bpValue(st.spacing, 0)) || 0;
    var box = t.clientWidth;
    var slides = [].slice.call(t.children);
    if (!box || slides.length < 2) return;
    // Only size a track whose children are the slides. Where a wrapper and a
    // slider are nested, the outer one's single child is the inner track, and
    // sizing that would fight the element that owns the real slides.
    var items = slides.filter(function (s) {
      return s.classList && s.classList.contains('gem-slider-item');
    });
    if (items.length < 2) return;
    slides = items;
    // The observer watches the same element this function writes into; bail when
    // nothing that affects the result has changed, so it cannot feed itself.
    /* The gap the track ACTUALLY renders, not the one the builder authored.

       This is the defect that kept coming back on every carousel in turn. The
       width was computed as (box - authoredSpacing * (per - 1)) / per while the
       track separately carried a CSS `gap`, so the real row was wider than the
       box by one gap per column and the last visible card was sliced off at the
       container edge. Measured on staging at 1440: FREE BONUSES authored
       spacing 0, rendered gap 24px, box 1233 -> slides 411 -> row 1281; IN THE
       BOX authored 0, rendered 30px, box 903 -> slides 301 -> row 963.

       Two numbers described one distance and nothing kept them equal. Now a
       single value feeds both: whichever spacing is real becomes `--bn-gap`,
       the track lays out with it, and the stylesheet derives the slide width
       from that same variable. They cannot drift apart again. */
    var cssGap = parseFloat(getComputedStyle(t).columnGap) || 0;
    if (!cssGap && gap) t.style.setProperty('column-gap', gap + 'px');
    var used = cssGap || gap;

    var sig = box + 'x' + per + 'x' + used + 'x' + slides.length;
    if (t.__bncSig === sig) return;
    t.__bncSig = sig;

    /* Publish the inputs; the stylesheet owns the arithmetic. Doing the division
       here in pixels is what allowed the two to disagree, and it also meant a
       track only ever laid out correctly if this function had already run. */
    t.style.setProperty('--bn-per', per);
    t.style.setProperty('--bn-gap', used + 'px');
    /* Marks a track whose per-view is known, so the stylesheet rule cannot
       reach a carousel authored with intrinsic ('auto') widths, which returns
       above and must keep its natural slide sizes. */
    t.classList.add('bn-track');

    slides.forEach(function (s) {
      /* Clear the pixel sizing older builds wrote inline. An inline declaration
         outranks the stylesheet even with !important, so leaving these behind
         would pin the slides at the wrong width for ever. */
      ['flex', 'width', 'max-width', 'min-width', 'margin-right'].forEach(function (p) {
        s.style.removeProperty(p);
      });
      s.style.scrollSnapAlign = 'start';
    });

    // Re-align after a resize; the track otherwise stays parked between two
    // slides, which is exactly the "first slide is offset" symptom.
    var stride = (box - used * (per - 1)) / per + used;
    if (stride > 0) t.scrollLeft = Math.round(t.scrollLeft / stride) * stride;
  }

  /* The product gallery is a two-column grid: a vertical thumbnail rail and the
     main image. The builder authors the rail wrapper at height 0 and its runtime
     gave the rail the main image's height. Without that the rail still occupies
     its grid column (118px) while rendering nothing, which reads as dead space
     on the left of the carousel and makes the module's gutters look uneven.
     Match the rail to the main track, and let it scroll if the thumbs overflow. */
  /* Product gallery: thumbnails under the photo.

     The builder lays the thumbnail rail out as a narrow vertical column beside
     the featured image, and authors it at zero height so it renders collapsed
     without its runtime. Rather than rebuild the thumbnails, move the rail the
     builder already produced below the image and lay it out horizontally, which
     is the arrangement shoppers expect. Thumbnails drive the main track, and the
     active one follows whatever the reader does to that track.

     Only touches a gallery that actually has a separate rail and main track. */
  /* Move the Shop Pay Installments banner and the trust line directly under the
     price, and label the currency. The price is written by the builder's own
     renderer as a bare "$421.00" with no currency code anywhere on the page, so
     a visitor shopping from outside the store's currency anchors on a number
     that changes character at checkout. Read the active currency at runtime so
     the label always matches whatever Markets actually serves. */
  /* Sequencing. As authored, the "resistance bands don't work" row sits between
     the problem cards and the row that explains what the trainer is, so the page
     spends the highest-value slot on the page - the screen directly below the
     fold - arguing against an alternative before the reader has been given a
     replacement, and the mechanism that answers "what is this" is pushed below
     it. Move the teardown to sit immediately AFTER the mechanism and BEFORE the
     proof stack, giving problem -> agitate -> mechanism -> teardown -> proof ->
     offer -> comparison. The teardown becomes the contrast to a mechanism the
     reader has just seen, and reviews run uninterrupted into the product module.

     The row is re-parented no further than the container that already holds the
     proof block, because lifting it out of its builder ancestor chain strips its
     styling and un-hides the opposite responsive variant (measured: 321px block
     collapsing to 93px, with both variants rendering). No copy changes. */
  function initSequenceFix() {
    var matches = $$('[data-bn="row"]').filter(function (r) {
      var t = (r.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 40);
      return t.toUpperCase().indexOf('RESISTANCE BANDS') === 0;
    });
    // Nested duplicates: keep only the outermost row of each group.
    var outer = matches.filter(function (r) {
      return !matches.some(function (o) { return o !== r && o.contains(r); });
    });
    outer.forEach(function (row) {
      if (row.__bnSeq) return;
      // The proof block is a custom-code island nested inside the mechanism row
      // that follows this one. Insert directly ahead of it.
      var proof = null;
      var sib = row.nextElementSibling;
      while (sib && !proof) {
        [].slice.call(sib.querySelectorAll('.bnc-custom-code')).forEach(function (c) {
          if (proof) return;
          if (/verified reviews/i.test(c.textContent || '') &&
              c.getBoundingClientRect().height > 200) proof = c;
        });
        sib = sib.nextElementSibling;
      }
      if (!proof || !proof.parentElement) return;
      row.__bnSeq = true;
      proof.parentElement.insertBefore(row, proof);
    });
  }

  /* Pop Up Technique Program upsell. Places the checkbox directly above the
     add-to-cart button - the last thing seen before the commit action - and,
     when ticked, adds the course alongside the trainer.

     Hooked on the button's CLICK in the capture phase, not on form submit: the
     add-to-cart never fires a submit event (measured - something intercepts the
     click and posts the FormData itself), so a submit listener never runs. The
     course is added and awaited first, then the click is replayed behind a pass
     flag so the theme's own add-to-cart and drawer handling run untouched.
     Sending both adds at once races two writes to the same cart.

     The reduction is an automatic discount in Shopify; nothing here sets price. */
  /* Bundle discount is a FIXED amount in the shop's BASE currency. Converting it
     is not optional: `price | minus: 5000` in Liquid subtracts 50 units of the
     presentment currency, which advertised $162.00 CAD where Shopify charges
     $141.43, and in a currency stronger than the base would advertise LESS than
     the customer pays. Same calculation as the cart drawer. */
  function bnBundleDiscountCents() {
    var rate = 1;
    if (window.Shopify && Shopify.currency && Shopify.currency.rate) {
      var r = parseFloat(Shopify.currency.rate);
      if (r > 0) rate = r;
    }
    return Math.round(5000 * rate);
  }
  function initUpsellPrice() {
    $$('[data-upsell-price]').forEach(function (box) {
      var full = parseInt(box.getAttribute('data-full-cents'), 10);
      var now = box.querySelector('[data-upsell-now]');
      var was = box.querySelector('[data-upsell-was]');
      if (!full || !now || !was) return;
      var off = bnBundleDiscountCents();
      if (off <= 0 || off >= full) { was.setAttribute('hidden', ''); return; }
      /* Both discounts reach this line, and in this order: the fixed bundle
         amount first, then the percentage on what is left. Measured in the cart
         with both in play - a $150.00 course carries a $50.00 bundle allocation
         and a $10.00 LABOR26 allocation, so LABOR26 is 10% of $100.00, not of
         $150.00. Quoting only the bundle advertised $100.00 against the $90.00
         actually charged. The rate is published by Liquid on the element so
         there is a single copy of it. */
      var net = full - off;
      var pct = parseInt(box.getAttribute('data-promo-pct') || '0', 10);
      if (pct > 0 && pct < 100) { net = Math.round(net * (100 - pct) / 100); }
      if (!(net > 0)) { was.setAttribute('hidden', ''); return; }
      now.textContent = was.textContent.replace(/[\d][\d.,]*/, (net / 100).toFixed(2));
      was.removeAttribute('hidden');
    });
  }

  /* ---------------------------------------------------------------------
     A repeat press of Add to cart opens the drawer; it never adds or bumps.

     Raising the quantity from here is not survivable: even a clean
     /cart/change.js on the existing line key comes back as TWO lines when
     the bundle discount is in the cart, because Shopify cannot keep a
     discount-allocated unit and a plain unit on one line. Measured on
     staging 2026-08-31: change.js {quantity:2} on the trainer's own key
     returned the original q1 line plus a new q1 line.

     Decision (Andy, 2026-08-31): nobody buys two trainers from the buy
     block, so a second press means "show me my cart". Quantity changes
     happen on the drawer's +/- controls. The course is once-only either
     way. The cart persists between visits, so an item can already be in
     the cart on the FIRST press of a later session - same path.
     --------------------------------------------------------------------- */
  function bnCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart read failed'); return r.json(); });
  }

  function bnLinesFor(cart, id) {
    var out = [];
    (cart.items || []).forEach(function (i) {
      if (i.variant_id === id) out.push({ key: i.key, qty: i.quantity });
    });
    return out;
  }

  /* items: [{ id, quantity }]  -  anything already in the cart is left alone. */
  function bnAddOrBump(items) {
    return bnCart().then(function (cart) {
      var toAdd = [];
      items.forEach(function (it) {
        if (!bnLinesFor(cart, it.id).length) toAdd.push({ id: it.id, quantity: it.quantity });
      });
      if (!toAdd.length) return;
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: toAdd })
      }).then(function (r) { if (!r.ok) throw new Error('add failed'); });
    });
  }

  /* Reflect cart state on the upsell row: once the course is in the cart the
     checkbox must not stay ticked, or the next press re-adds it. */
  function bnSyncUpsell() {
    var box = document.querySelector('.bn-upsell');
    if (!box) return;
    var cb = box.querySelector('.bn-upsell__cb');
    if (!cb) return;
    var vid = parseInt(cb.getAttribute('data-variant-id'), 10);
    if (!vid) return;
    bnCart().then(function (cart) {
      var inCart = bnLinesFor(cart, vid).length > 0;
      if (inCart) { cb.checked = false; cb.disabled = true; }
      else { cb.disabled = false; }
      box.classList.toggle('bn-upsell--in-cart', inCart);
    }).catch(function () {});
  }

  function initUpsellCartSync() {
    bnSyncUpsell();
    ['cart:build', 'cart:open', 'cart:updated'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(bnSyncUpsell, 250); });
    });
  }

  function initUpsell() {
    var box = $('.bn-upsell');
    if (!box || box.__bnUp) return;
    var btn = $('form[action*="/cart/add"] [name="add"]');
    if (!btn || !btn.parentElement) return;
    box.__bnUp = true;
    box.removeAttribute('hidden');
    btn.parentElement.insertBefore(box, btn);

    document.addEventListener('click', function (e) {
      var hit = e.target.closest && e.target.closest('[name="add"]');
      if (!hit) return;
      if (hit.__bnUpPass) { hit.__bnUpPass = false; return; }
      /* Intercept EVERY press, not only the ones with the box ticked.
         This buy block is the builder's, so it has no #bn-atc-form and
         initSingleSubmitATC never binds here. Returning early when the box was
         clear handed the press back to the theme's own add, which appended a
         second trainer line instead of raising the first - measured: two lines
         at quantity 1 rather than one line at quantity 2. */
      var cb = box.querySelector('.bn-upsell__cb');
      var vid = cb && cb.checked ? parseInt(cb.getAttribute('data-variant-id'), 10) : 0;
      var form = hit.closest('form');
      var main = form && form.querySelector('[name="id"]');
      var mainId = main ? parseInt(main.value, 10) : 0;
      if (!mainId) return;
      /* One request, not two. Previously the course was added in its own call
         and then the click was replayed so the theme added the trainer, which
         meant a single click issued two independent POSTs - if the second failed
         the buyer left with half the order and only discovered it at checkout.
         `/cart/add.js` takes an items array, so both lines go in one atomic
         call, and the drawer is opened through the theme's own event. */
      e.preventDefault();
      e.stopImmediatePropagation();
      hit.setAttribute('disabled', 'disabled');
      var qtyEl = form.querySelector('[name="quantity"]');
      var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
      var items = [{ id: mainId, quantity: qty }];
      if (vid) items.push({ id: vid, quantity: 1 });
      bnAddOrBump(items).then(function () {
        hit.removeAttribute('disabled');
        /* Untick before the drawer opens: the course is in the cart now, and a
           still-ticked box is what turned the next press into a second copy. */
        if (cb) cb.checked = false;
        bnSyncUpsell();
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      }).catch(function () {
        /* Fall back to the theme's own path so the buyer is never left with
           nothing happening. */
        hit.removeAttribute('disabled');
        hit.__bnUpPass = true;
        hit.click();
      });
    }, true);

    /* Info panel: hover is handled in CSS for pointer devices; this covers
       click, touch, and keyboard, and closes on outside click or Escape. */
    var info = box.querySelector('.bn-upsell__info');
    var tip = box.querySelector('.bn-upsell__tip');
    if (info && tip) {
      var setTip = function (open) {
        tip.hidden = !open;
        info.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      info.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setTip(tip.hidden);
      });
      info.addEventListener('mouseenter', function () { setTip(true); });
      box.addEventListener('mouseleave', function () { setTip(false); });
      document.addEventListener('click', function (e) {
        if (!box.contains(e.target)) setTip(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') setTip(false);
      });
    }
  }

  function initPriceBlock() {
    var price = $('[data-bn="product-price"]');
    if (!price) return;

    var pay = $('.bn-pay');
    if (pay && !pay.__bnMoved) {
      pay.__bnMoved = true;
      pay.removeAttribute('hidden');
      var host = price.parentElement || price;
      if (host.nextSibling) host.parentElement.insertBefore(pay, host.nextSibling);
      else host.parentElement.appendChild(pay);
    }

    if (!price.__bnCcy) {
      /* Label the currency only when the buyer is being served something other
         than the store's base. A US visitor on a USD store reading "$299.00 USD"
         is noise; a Canadian visitor reading "$421.00" with no code is the
         ambiguity worth removing. Rate 1 means this session is the base. */
      var cur = (window.Shopify && Shopify.currency) || {};
      var ccy = cur.active || '';
      if (parseFloat(cur.rate) === 1) ccy = '';
      var txt = (price.textContent || '');
      if (ccy && txt.indexOf(ccy) === -1 && /\d/.test(txt)) {
        price.__bnCcy = true;
        /* Append into the element that actually holds the money text, not the
           container. The container wraps the amount in a child, so appending at
           that level put the code on its own line under the price with the
           container's full line-height between them. */
        var host = price;
        for (var guard = 0; guard < 6; guard++) {
          var next = null;
          [].slice.call(host.children).forEach(function (k) {
            if (next) return;
            if (/[0-9]/.test(k.textContent || '')) next = k;
          });
          if (!next) break;
          host = next;
        }
        var tag = document.createElement('span');
        tag.className = 'bn-ccy';
        tag.textContent = ccy;
        host.appendChild(tag);
      }
    }
  }

  /* Pagination dots. The builder authors a dot container and marks dot:true in
     its config, but its runtime was what filled it - without that the container
     rendered empty, so a multi-slide block gave the reader no sign it could be
     swiped at all. Build the dots from the slides themselves.

     One dot per slide rather than per scroll-page: the reader is counting cards,
     not viewport pages, and with two cards visible of three a two-dot indicator
     reads as if a card is missing. */
  /* Review counts. The figure is baked into several section settings, where
     Liquid is not evaluated, so it drifts every time Loox gains a review - the
     page was showing 282 in one place and 281 in another while Loox said 284.
     Rewrite the digits from the live metafield, matching only "<n> verified
     reviews" so no other number on the page is touched. */
  function initReviewCounts() {
    var live = window.__bnReviews && window.__bnReviews.count;
    if (!live) return;
    var re = /\b\d[\d,]*(\s+verified reviews)/i;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var hits = [], n;
    while ((n = walker.nextNode())) {
      if (re.test(n.nodeValue)) hits.push(n);
    }
    hits.forEach(function (node) {
      node.nodeValue = node.nodeValue.replace(re, live + '$1');
    });
  }

  /* On-device overflow probe. Emulated viewports resolve fixed elements against
     the real window here, so sideways-scroll reports from a real handset cannot
     be reproduced or disproved locally. Loading any page with ?bnoverflow=1
     names the offenders on the device itself. Inert without the flag. */
  /* On-device overflow probe: append ?bnoverflow=1 to any URL.
     Exists because a desktop browser resized to a phone width is NOT a phone.
     `resize_window`-style emulation changes documentElement.clientWidth but not
     the initial containing block, so every `position:fixed` element resolves
     against the outer window and reads hundreds of px too wide, while
     body.scrollWidth reads perfectly clean. Both numbers are wrong in opposite
     directions, which is how a real horizontal-scroll bug survived repeated
     "verified at 375px" passes. This runs on the actual handset instead. */
  /* ITEM 2 (QA doc): GemPages' `gp-rich-snippets` app snippet emits Product
     JSON-LD with a fixed `priceValidUntil` equal to the build date. Once that
     date passes, Google can drop the price from rich results.

     The snippet is injected by the GemPages app embed in <head>, so it is not
     editable from the theme, and the embed cannot be disabled: 43 templates
     still render gp-* sections and would lose their runtime. Roll the date
     forward in the rendered DOM instead - Google reads structured data from the
     rendered page. Durable fix is to drop the snippet in the GemPages app once
     the remaining 43 templates are migrated. */
  /* ITEM 5 (QA doc): the homepage buy block reported add_to_cart twice for a
     single item. Its button is a plain submit inside a real {% form 'product' %},
     so the click produces a NATIVE form submit which Impulse then re-issues as
     an AJAX /cart/add.js. GTM sees both - once on `gtm.formSubmit` and once on
     the cart request - and pushes add_to_cart for each. Measured: homepage
     1 request / 1 item / 2 events; the variant, whose click is intercepted,
     1 / 1 / 1.

     Left alone this corrupts the A/B read: the control side double-counts and
     wins on a tagging artefact.

     Fix: intercept the submit so no native form-submit event is ever produced,
     and issue the same single atomic add the variant uses. The upsell handler
     binds on the button in the capture phase and stops propagation, so when an
     upsell is present it runs instead of this and still produces exactly one
     request. On failure we fall through to a native submit so the buyer is
     never left with a dead button. */
  function initSingleSubmitATC() {
    var form = document.getElementById('bn-atc-form');
    if (!form || form.__bnSingle) return;
    var btn = form.querySelector('[name="add"]');
    if (!btn) return;
    form.__bnSingle = true;
    /* Bind on the BUTTON in the capture phase, not on the form's submit event.
       Impulse binds its own click handler that builds FormData and POSTs
       /cart/add.js itself, so cancelling only the submit still left Impulse's
       handler running - one click then produced TWO cart requests, which is the
       very defect item 4 describes, recreated on the control page. Capturing the
       click and stopping immediate propagation prevents Impulse's handler AND
       the native submit, leaving exactly one request and one add_to_cart event.
       Same mechanism the upsell handler uses. */
    btn.addEventListener('click', function (e) {
      if (btn.__bnPass) { btn.__bnPass = false; return; }      // deliberate fallback
      var idEl = form.querySelector('[name="id"]');
      var id = idEl ? parseInt(idEl.value, 10) : 0;
      if (!id) return;                                          // no id: let it through
      var qEl = form.querySelector('[name="quantity"]');
      var qty = qEl ? (parseInt(qEl.value, 10) || 1) : 1;
      e.preventDefault();
      e.stopImmediatePropagation();
      btn.setAttribute('disabled', 'disabled');
      /* Same rule as the upsell path: with the item already in the cart this
         adds nothing and the press just opens the drawer. Quantity changes
         happen on the drawer's +/- controls. */
      bnAddOrBump([{ id: id, quantity: qty }]).then(function () {
        btn.removeAttribute('disabled');
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      }).catch(function () {
        /* Never leave the buyer with a dead button. */
        btn.removeAttribute('disabled');
        btn.__bnPass = true;
        btn.click();
      });
    }, true);
  }

  function initSchemaDates() {
    var d = new Date();
    d.setFullYear(d.getFullYear() + 1);
    var iso = d.toISOString().slice(0, 10);
    var nodes = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.textContent.indexOf('priceValidUntil') === -1) continue;
      try {
        n.textContent = n.textContent.replace(
          /("priceValidUntil"\s*:\s*")[^"]*(")/g, '$1' + iso + '$2');
      } catch (e) { /* never let schema tidying break the page */ }
    }
  }

  function initOverflowProbe() {
    if (location.search.indexOf('bnoverflow=1') === -1) return;
    function scan() {
      var de = document.documentElement, body = document.body;
      var vw = de.clientWidth, out = [];
      /* Does the document ACTUALLY scroll sideways? `overflow:clip` still
         reports a large scrollWidth while forbidding the scroll, so scrollWidth
         alone proves nothing. Ask the scroller to move and see if it does. */
      var sx0 = window.scrollX;
      window.scrollTo(vw * 4, window.scrollY);
      var scrollable = Math.round(window.scrollX);
      window.scrollTo(sx0, window.scrollY);

      var all = document.querySelectorAll('body *');
      for (var i = 0; i < all.length; i++) {
        var el = all[i], r = el.getBoundingClientRect();
        if (r.width < 1 || r.height < 1 || r.right <= vw + 1) continue;
        var cs = getComputedStyle(el);
        /* A fixed element is positioned against the viewport, so overflow on
           html/body cannot clip it. Over-wide fixed elements are therefore the
           one class that produces horizontal scroll on iOS no matter what
           containment the page declares. Never treat them as clipped. */
        var fixed = cs.position === 'fixed';
        var clipped = false;
        if (!fixed) {
          var n = el.parentElement;
          /* Stop BELOW body. body and html carry the page's own overflow-x
             containment, so walking into them marks every element clipped and
             the probe reports "none" for every page, always. */
          while (n && n !== body) {
            if (/auto|hidden|scroll|clip/.test(getComputedStyle(n).overflowX)) {
              clipped = true; break;
            }
            n = n.parentElement;
          }
        }
        if (clipped) continue;
        el.style.outline = '2px solid #ff0055';
        out.push(Math.round(r.right) + 'px w' + Math.round(r.width) +
                 (fixed ? ' FIXED ' : ' ') + el.tagName.toLowerCase() +
                 (el.id ? '#' + el.id : '') +
                 '.' + String(el.className || '').split(' ').slice(0, 2).join('.'));
      }
      out.sort(function (a, b) { return parseInt(b, 10) - parseInt(a, 10); });

      var box = document.getElementById('bn-ovf') || document.createElement('div');
      box.id = 'bn-ovf';
      box.style.cssText = 'position:fixed;left:8px;right:8px;bottom:8px;z-index:2147483647;' +
        'background:#111;color:#fff;font:12px/1.45 monospace;padding:10px 12px;' +
        'border-radius:8px;max-height:46vh;overflow:auto;white-space:pre-wrap';
      box.textContent =
        'viewport ' + vw + ' · innerWidth ' + window.innerWidth +
        (window.innerWidth !== vw ? '  <- MISMATCH: emulated, not a real device' : '') +
        '\nhtml.scrollWidth ' + de.scrollWidth + ' · body.scrollWidth ' + body.scrollWidth +
        '\nactually scrolls sideways: ' + (scrollable > 1 ? scrollable + 'px  <- BUG' : 'no') +
        '\noverhanging (' + out.length + '):' +
        (out.length ? '\n  ' + out.slice(0, 14).join('\n  ') : ' none');
      if (!box.parentElement) body.appendChild(box);
    }
    scan();
    setTimeout(scan, 2500);       // after apps and lazy content mount
    window.addEventListener('resize', scan);
    window.addEventListener('orientationchange', function () { setTimeout(scan, 300); });
  }

  function initDots(t) {
    if (t.__bnDots) return;
    var slides = [].slice.call(t.children).filter(function (s) {
      return s.getBoundingClientRect().width > 1;
    });
    if (slides.length < 2) return;
    if (t.scrollWidth - t.clientWidth < 8) return;
    /* The product gallery already shows a thumbnail strip, which is a stronger
       position indicator than dots and covers the same job. Two indicators for
       one track is noise, and 11 dots is not a usable control. */
    if (t.closest('.bn-gal')) return;
    /* Same rule for the builder's gallery: it renders its own thumbnail rail
       (one per breakpoint, the inactive ones display:none), which is a stronger
       position indicator than dots and does the same job. Dots here rendered
       over the thumbnails, and at 11 slides they are not a usable control
       anyway. Check for a rail anywhere in the carousel's ancestry. */
    var gscope = t.parentElement, ghops = 0;
    while (gscope && gscope !== document.body && ghops++ < 8) {
      if (gscope.querySelector('[id^="bnc-carousel-bnc-gallery"]')) return;
      gscope = gscope.parentElement;
    }
    t.__bnDots = true;

    /* Own the container. The builder's dot element is not reliably reachable
       from the track - it sits outside its ancestry - so create one and place it
       directly after the track. Its own empty container stays collapsed. */
    var cont = document.createElement('div');
    cont.className = 'bn-dots';
    /* Insert BELOW the flex row, not inside it. Dropping a full-width div in as
       a sibling of the track made it a flex item competing for width, which
       halved several tracks (355px -> 160px) and broke headings mid-word.
       Walk up past any row-flex ancestry first, so the dots land in a block
       context and cannot take width from the carousel. */
    var ref = t;
    while (ref.parentElement && ref.parentElement !== document.body) {
      var pc = getComputedStyle(ref.parentElement);
      var isRow = (pc.display === 'flex' || pc.display === 'inline-flex') &&
                  pc.flexDirection.indexOf('row') === 0;
      if (!isRow) break;
      ref = ref.parentElement;
    }

    /* A rebuild replaces this container, and the superseded closure keeps its
       own `cont` plus two pending timers. Those timers used to re-enter
       initDots and insert ANOTHER container without removing the current one,
       so every extra rebuild cycle left one more dot row in the DOM: measured
       2 rows on variant/mobile, 3 on variant/desktop, 2 on control/desktop.
       Track the live container on the element and let a stale closure retire
       itself. Also sweep any container a previous cycle orphaned, so a page
       that already leaked one recovers instead of compounding. */
    if (t.__bnDotsCont && t.__bnDotsCont.parentElement) t.__bnDotsCont.remove();
    t.__bnDotsCont = cont;

    if (ref.nextSibling) ref.parentElement.insertBefore(cont, ref.nextSibling);
    else ref.parentElement.appendChild(cont);

    /* One dot per REACHABLE SCROLL POSITION, not per slide.
       With more than one slide in view the last slides are already on screen
       when the track hits its maximum, so there is nothing left to scroll to and
       the trailing dots are dead. Measured on the problem-cards carousel:
       3 slides, 2.07 per view, maxScrollLeft 191 - clicking the three dots
       landed at [0, 191, 191], so dot 3 did nothing.

       Derive the targets from the DOM instead of a formula: take each slide's
       offset, clamp to maxScroll, and drop duplicates. That is correct for any
       slides-per-view, gap, or uneven slide width, and needs no knowledge of the
       builder's config. */
    function positions() {
      var max = t.scrollWidth - t.clientWidth;
      if (max < 1) return [0];
      var base = slides[0].offsetLeft, out = [];
      for (var i = 0; i < slides.length; i++) {
        var pos = slides[i].offsetLeft - base;
        if (pos > max) pos = max;
        if (pos < 0) pos = 0;
        /* 4px tolerance: sub-pixel layout and scroll-snap rounding otherwise
           produce two "distinct" targets a hair apart, i.e. another dead dot. */
        if (!out.length || Math.abs(pos - out[out.length - 1]) > 4) out.push(pos);
      }
      if (out.length && Math.abs(out[out.length - 1] - max) > 4) out.push(max);
      return out;
    }

    var pos = positions();
    if (pos.length < 2) { t.__bnDots = false; cont.remove();
                          if (t.__bnDotsCont === cont) t.__bnDotsCont = null; return; }

    function sync() {
      var cur = t.scrollLeft, best = 0, bestD = Infinity;
      for (var i = 0; i < pos.length; i++) {
        var d = Math.abs(pos[i] - cur);
        if (d < bestD) { bestD = d; best = i; }
      }
      [].slice.call(cont.children).forEach(function (d, n) {
        d.classList.toggle('is-active', n === best);
        d.setAttribute('aria-current', n === best ? 'true' : 'false');
      });
    }

    pos.forEach(function (target, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bn-dot';
      b.setAttribute('aria-label', 'Show view ' + (i + 1) + ' of ' + pos.length);
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        t.__bncUserMoved = true;
        t.style.setProperty('scroll-behavior', 'auto', 'important');
        t.scrollLeft = target;
        sync();
      });
      cont.appendChild(b);
    });

    /* Slide widths settle after fonts and images load, which moves the targets.
       Rebuild rather than leave a stale dot count behind. */
    function rebuild() {
      /* Retired closure: a later cycle owns the dots now. Doing anything here
         is what produced the duplicate rows. */
      if (t.__bnDotsCont !== cont) return;
      var next = positions();
      if (next.length === pos.length) { pos = next; sync(); return; }
      /* Remove the old container, do not just empty it. initDots creates a
         fresh one on every call, so emptying left an orphaned `.bn-dots` in the
         DOM for each rebuild - an empty dot row stacking up under the track. */
      cont.remove();
      t.__bnDots = false;
      initDots(t);
    }
    t.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', function () { clearTimeout(t.__bnDotT);
      t.__bnDotT = setTimeout(rebuild, 200); });
    sync();
    setTimeout(rebuild, 600);
    setTimeout(rebuild, 2000);
  }

  function initProductGallery(mainTrack) {
    var grid = mainTrack.closest('[class*="bnc-featured-image-wrap"]');
    grid = grid && grid.parentElement && grid.parentElement.parentElement;
    if (!grid) return;
    var rail = null;
    [].slice.call(grid.querySelectorAll('.gem-slider')).forEach(function (g) {
      if (g !== mainTrack && !rail) rail = g;
    });
    if (!rail) return;
    if (rail.children.length !== mainTrack.children.length) return;
    /* Scoped to the homepage-var product module. The same builder component
       appears elsewhere with a different width basis - on the control homepage
       the featured image draws its width from the two-column grid this layout
       flattens, and collapses to its content minimum when converted. Widen the
       scope only after checking each page it would newly apply to. */
    if (!mainTrack.closest('[id*="gp_section_633372537883787861"]')) return;

    /* Relocate once. Everything after is idempotent and re-runs on each call,
       so a second invocation refreshes the active state instead of taking an
       early return into half-initialised scope. */
    if (!grid.__bnGalMoved) {
      grid.__bnGalMoved = true;
      grid.classList.add('bn-gal');
      var mainBox = mainTrack.parentElement;
      while (mainBox && mainBox.parentElement !== grid) mainBox = mainBox.parentElement;
      if (mainBox) mainBox.classList.add('bn-gal__main');

      /* Move the rail into a wrapper of our own rather than relocating one of
         the builder's ancestors: the rail sits several levels inside a gallery
         wrapper whose boundaries are not safe to guess at, and moving the wrong
         one orphans the track. Owning the container makes placement exact. */
      var oldHome = rail.parentElement;
      var box = document.createElement('div');
      box.className = 'bn-gal__rail';
      box.appendChild(rail);
      grid.appendChild(box);

      /* The containers the rail came out of are authored at zero height and
         would otherwise leave a gap where the vertical column used to be. */
      for (var a = oldHome; a && a !== grid; a = a.parentElement) {
        if (!a.querySelector('.gem-slider')) {
          a.style.setProperty('display', 'none', 'important');
        }
      }
    }

    rail.style.setProperty('height', 'auto', 'important');
    rail.style.setProperty('min-height', '0', 'important');
    rail.style.setProperty('max-height', 'none', 'important');
    rail.style.setProperty('width', '100%', 'important');
    rail.style.setProperty('flex-direction', 'row', 'important');
    /* The builder's utility layer wraps this track on desktop, which drops the
       11 thumbs onto a second row once they overflow the rail. It scrolls. */
    rail.style.setProperty('flex-wrap', 'nowrap', 'important');
    rail.style.setProperty('overflow-x', 'auto', 'important');
    rail.style.setProperty('overflow-y', 'hidden', 'important');
    rail.style.setProperty('scroll-behavior', 'auto', 'important');

    var thumbs = [].slice.call(rail.children);

    function syncActive() {
      var first = mainTrack.children[0];
      if (!first) return;
      var w = first.getBoundingClientRect().width || 1;
      var i = Math.round(mainTrack.scrollLeft / w);
      thumbs.forEach(function (th, n) {
        th.classList.toggle('is-active', n === i);
        th.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (th, i) {
      th.classList.add('bn-gal__thumb');
      /* The builder sizes each thumb to the full rail width via inline --minw
         / --maxw custom properties, which is correct for a vertical column and
         wrong for a strip. Clear them so the stylesheet's square wins. */
      ['--minw', '--maxw', '--minw-tablet', '--maxw-tablet',
       '--minw-mobile', '--maxw-mobile', '--w', '--h'].forEach(function (v) {
        th.style.removeProperty(v);
      });
      /* Size inline: the thumb carries the builder's `bnc-w-full` utility, and
         a stylesheet rule - even !important - cannot outrank an important
         declaration from that utility layer. Inline !important can. */
      // clientWidth, not innerWidth: innerWidth reports the window, which
      // can differ from the layout viewport the page is actually laid out in.
      var sz = document.documentElement.clientWidth < 768 ? 64 : 84;
      th.style.setProperty('flex', '0 0 ' + sz + 'px', 'important');
      th.style.setProperty('width', sz + 'px', 'important');
      th.style.setProperty('min-width', sz + 'px', 'important');
      th.style.setProperty('max-width', sz + 'px', 'important');
      th.style.setProperty('height', sz + 'px', 'important');
      if (th.__bnThumb) return;
      th.__bnThumb = true;
      th.setAttribute('role', 'button');
      th.setAttribute('tabindex', '0');
      th.setAttribute('aria-label', 'Show image ' + (i + 1));
      function pick(e) {
        if (e) { e.preventDefault(); e.stopPropagation(); }
        var slide = mainTrack.children[i];
        if (!slide) return;
        mainTrack.__bncUserMoved = true;
        mainTrack.__bncProgrammatic = true;
        mainTrack.style.setProperty('scroll-behavior', 'auto', 'important');
        mainTrack.scrollLeft = slide.offsetLeft - mainTrack.children[0].offsetLeft;
        setTimeout(function () { mainTrack.__bncProgrammatic = false; }, 60);
        syncActive();
      }
      th.addEventListener('click', pick);
      th.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') pick(e);
      });
    });

    /* Size the photo so the WHOLE carousel - image plus thumbnail strip - sits
       inside the viewport while the column is stuck. The sticky column is taller
       than the photo by a fixed overhead (strip, gap, padding), so the photo is
       the only variable: cap it at whatever is left after the sticky offset and
       that overhead. Scaled on both axes from the natural ratio, so the framing
       is unchanged rather than cropped harder. Desktop only - there is no sticky
       column on mobile, where the photo should keep its natural size. */
    function fitStickyGallery() {
      /* The rail can be outside a .bn-gal when this fires: the theme editor
         re-renders the section and this closure holds the detached copy. */
      var gal = rail.closest('.bn-gal');
      var box = gal && gal.querySelector('.bn-gal__main');
      var slides = [].slice.call(mainTrack.children);
      function clear() {
        [box, mainTrack].forEach(function (el) {
          if (!el) return;
          ['height', 'max-height', 'max-width'].forEach(function (pr) {
            el.style.removeProperty(pr);
          });
        });
        slides.forEach(function (sl) { sl.style.removeProperty('height'); });
      }
      if (!box) return;
      if (document.documentElement.clientWidth < 768) { clear(); return; }

      var sticky = box;
      while (sticky && getComputedStyle(sticky).position !== 'sticky') {
        sticky = sticky.parentElement;
      }
      if (!sticky) { clear(); return; }

      // Measure the natural size once, before any cap of ours is in place.
      clear();
      var nat = mainTrack.getBoundingClientRect();
      if (!nat.height || !nat.width) return;
      var ratio = nat.width / nat.height;
      var overhead = sticky.getBoundingClientRect().height - nat.height;
      var top = parseFloat(getComputedStyle(sticky).top) || 0;

      /* The sticky add-to-cart bar covers the bottom of the viewport, so the
         space the gallery can occupy ends at the TOP of that bar, not at the
         bottom of the window. Without this the thumbnail strip sizes into the
         viewport correctly and then sits underneath the bar. Measure the bar's
         own height rather than its position: it is fixed, and its offset from
         the bottom is its own (a preview bar can lift it). */
      var reserve = 0;
      var satc = $('.bn-satc');
      if (satc) {
        var scs = getComputedStyle(satc);
        var sh = satc.getBoundingClientRect().height;
        if (scs.position === 'fixed' && scs.display !== 'none' &&
            scs.visibility !== 'hidden' && sh > 0) {
          reserve = sh + (parseFloat(scs.bottom) || 0);
        }
      }

      var capH = Math.round(document.documentElement.clientHeight - top - overhead - reserve - 16);
      if (capH >= nat.height) return;          // already fits: leave it alone
      if (capH < 300) capH = 300;              // never shrink to unusable
      var capW = Math.round(capH * ratio);

      [box, mainTrack].forEach(function (el) {
        el.style.setProperty('height', capH + 'px', 'important');
        el.style.setProperty('max-height', capH + 'px', 'important');
        el.style.setProperty('max-width', capW + 'px', 'important');
      });
      box.style.setProperty('margin-left', 'auto', 'important');
      box.style.setProperty('margin-right', 'auto', 'important');
      slides.forEach(function (sl) {
        sl.style.setProperty('height', capH + 'px', 'important');
        var md = sl.querySelector('img,video');
        if (md) {
          md.style.setProperty('height', '100%', 'important');
          md.style.setProperty('width', '100%', 'important');
          md.style.setProperty('object-fit', 'cover', 'important');
        }
      });
    }
    fitStickyGallery();
    setTimeout(fitStickyGallery, 400);
    setTimeout(fitStickyGallery, 1400);   // after the sticky bar clamps itself

    if (!mainTrack.__bnGalSync) {
      mainTrack.__bnGalSync = true;
      mainTrack.addEventListener('scroll', syncActive, { passive: true });
      var __gr;
      window.addEventListener('resize', function () {
        clearTimeout(__gr);
        __gr = setTimeout(function () { initProductGallery(mainTrack); }, 150);
      });
      window.addEventListener('load', fitStickyGallery);
    }
    syncActive();
    setTimeout(syncActive, 300);
  }

  function sizeThumbRail(scope) {
    var tracks = [].slice.call(scope.querySelectorAll('.gem-slider'));
    if (tracks.length < 2) return;
    var main = null, rail = null;
    tracks.forEach(function (t) {
      var w = t.getBoundingClientRect().width;
      if (w >= 300 && (!main || w > main.getBoundingClientRect().width)) main = t;
      else if (w > 0 && w < 300 && !rail) rail = t;
    });
    if (!main || !rail) return;
    var h = Math.round(main.getBoundingClientRect().height);
    if (h < 80) return;
    var host = rail.parentElement;
    for (var i = 0; i < 3 && host; i++) {
      host.style.setProperty('height', h + 'px', 'important');
      host.style.setProperty('min-height', h + 'px', 'important');
      host = host.parentElement;
    }
    rail.style.setProperty('height', h + 'px', 'important');
    rail.style.setProperty('max-height', h + 'px', 'important');
    rail.style.setProperty('overflow-y', 'auto', 'important');
    rail.style.setProperty('overflow-x', 'hidden', 'important');
    rail.style.setProperty('flex-direction', 'column', 'important');
    [].slice.call(rail.children).forEach(function (c) {
      c.style.setProperty('flex', '0 0 auto', 'important');
      c.style.setProperty('width', '100%', 'important');
    });
  }

  function initSliderTrack(t) {
    if (t.__bncTrack) return; t.__bncTrack = true;
    /* Size on every width change rather than once at init. A track inside a
       tab, an accordion, or a not-yet-laid-out column reports clientWidth 0 at
       init, and a one-shot call there leaves its slides at intrinsic width -
       which is the row that runs off the edge. */
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { sizeSlides(t); });
      ro.observe(t);
    }
    /* Native swipe for every managed track. The vendor's `bnc-overflow-hidden`
       class computes to overflow-x:hidden, which still allows programmatic
       scrollLeft (arrows and drag work) but blocks touch panning - so the
       gallery was not swipeable, most importantly on mobile. Set it inline:
       a stylesheet rule loses to the section's own inline <style>. Safe on the
       TRACK; the earlier collapse came from setting overflow on the carousel
       HOST, which is a grid item whose row is `fit-content(0)`. */
    t.style.setProperty('overflow-x', 'auto', 'important');
    t.style.setProperty('scrollbar-width', 'none', 'important');

    /* Wire the builder's own arrows. It marks them with
       aria-label="Carousel Back Arrow" / "Carousel Next Arrow" - read that
       rather than guessing at class names. They sit inside the /cart/add form,
       so they must never submit: they already carry type="button", and the
       theme's cart interceptor is guarded separately in layout/theme.liquid. */
    (function () {
      var host = t.closest('[data-bn="carousel"],[data-bn-role="carousel"],[data-bn="product-images"],[data-bn="carousel-v3"]')
              || t.parentElement;
      if (!host) return;
      var back = host.querySelector('[aria-label*="Back Arrow" i]');
      var next = host.querySelector('[aria-label*="Next Arrow" i]');
      if (!back && !next) return;
      function step() {
        var kids = [].slice.call(t.children).filter(function (c) {
          return c.classList && c.classList.contains('gem-slider-item');
        });
        if (kids.length < 2) return t.clientWidth;
        var a = kids[0].getBoundingClientRect(), b = kids[1].getBoundingClientRect();
        var vertical = Math.abs(b.top - a.top) > Math.abs(b.left - a.left);
        return vertical ? (b.top - a.top) : (b.left - a.left);
      }
      /* Direct assignment, not scrollTo({behavior:'smooth'}). The smooth
         animation is defeated here - measured landing back at 0 every time -
         while a plain scrollLeft assignment lands correctly and scroll-snap
         settles it. Easing comes from `scroll-behavior` on the element. */
      function go(dir) {
        var kids = [].slice.call(t.children).filter(function (c) {
          return c.classList && c.classList.contains('gem-slider-item');
        });
        var a = kids[0] ? kids[0].getBoundingClientRect() : null;
        var b = kids[1] ? kids[1].getBoundingClientRect() : null;
        var vertical = a && b && Math.abs(b.top - a.top) > Math.abs(b.left - a.left);
        var d = step() * dir;
        /* Force instant. Smooth scrolling does not complete on this track -
           both scrollTo({behavior:'smooth'}) and a plain assignment made under
           `scroll-behavior: smooth` were measured landing back at 0, while an
           instant assignment lands correctly and scroll-snap settles it. */
        t.style.setProperty('scroll-behavior', 'auto', 'important');
        if (vertical) t.scrollTop = t.scrollTop + d;
        else t.scrollLeft = t.scrollLeft + d;
      }
      [[back, -1], [next, 1]].forEach(function (pair) {
        var el = pair[0], dir = pair[1];
        if (!el || el.__bnArrow) return;
        el.__bnArrow = true;
        el.setAttribute('type', 'button');
        el.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          go(dir);
        });
      });
    })();

    sizeSlides(t);
    initDots(t);
    setTimeout(function () { initDots(t); }, 600);
    var __gal = t.closest('[data-bn="product-images"],[class*="bnc-gallery-"]')
             || t.parentElement;
    if (__gal) { initProductGallery(t); setTimeout(function(){ initProductGallery(t); }, 200); }
    var __rs; window.addEventListener('resize', function () {
      clearTimeout(__rs); __rs = setTimeout(function () {
        sizeSlides(t);
        /* Rebuild the dots too. Their targets are captured once from the slide
           offsets, so a width change that alters slides-per-view otherwise
           leaves a dot count describing the previous breakpoint - three dots
           against two reachable positions, the trailing one dead. */
        t.__bnDots = false;
        initDots(t);
      }, 150);
    });


    // Load every slide's media up front. An IntersectionObserver never fires
    // for slides parked off to the right inside a horizontally-clipped track:
    // they are outside the scroll container, not below the fold. The result is
    // a slide that renders its alt text instead of its image the moment the
    // carousel advances to it. Galleries hold a handful of images, so eager
    // loading here is cheap and removes the failure mode entirely.
    [].forEach.call(t.querySelectorAll('[data-src]:not([data-bnc-loaded]),[data-srcset]:not([data-bnc-loaded])'), swapMedia);

    var slides = function () { return $$(':scope > *', t); };
    var index = function () {
      var best = 0, d = Infinity;
      slides().forEach(function (s, i) {
        var x = Math.abs(s.offsetLeft - t.offsetLeft - t.scrollLeft);
        if (x < d) { d = x; best = i; }
      });
      return best;
    };
    var go = function (i, smooth) {
      var s = slides(); if (!s.length) return;
      i = (i + s.length) % s.length;
      if (!s[i]) return;
      // Flag programmatic movement. Auto-advance emits scroll events and the
      // scroll handler pauses autoplay — without this the first tick silences
      // the carousel permanently.
      t.__bncProgrammatic = true;
      clearTimeout(t.__bncProgT);
      t.__bncProgT = setTimeout(function () { t.__bncProgrammatic = false; }, 900);
      t.scrollTo({ left: s[i].offsetLeft - t.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    };

    // mouse drag (touch is native and better left alone)
    var down = false, moved = false, x0 = 0, l0 = 0, pid = null;
    t.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button !== 0) return;
      down = true; moved = false; pid = e.pointerId; x0 = e.clientX; l0 = t.scrollLeft;
      t.classList.add('is-grabbing'); t.style.scrollSnapType = 'none'; stop();
    });
    t.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pid) return;
      var dx = e.clientX - x0;
      if (!moved && Math.abs(dx) > 4) { moved = true; try { t.setPointerCapture(pid); } catch (x) {} }
      if (!moved) return;
      e.preventDefault(); t.scrollLeft = l0 - dx;
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      t.addEventListener(ev, function () {
        if (!down) return;
        down = false; t.classList.remove('is-grabbing'); t.style.scrollSnapType = '';
        if (pid !== null) { try { t.releasePointerCapture(pid); } catch (x) {} }
        pid = null; if (moved) go(index());
      });
    });
    t.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    t.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // keyboard
    t.setAttribute('tabindex', t.getAttribute('tabindex') || '0');
    t.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); stop(); go(index() + 1); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); stop(); go(index() - 1); }
    });

    /* No autoplay. A product gallery that advances on its own moves the image
       out from under the reader, and whichever slide it happens to be showing
       on arrival reads as a random first image. The track moves only when the
       reader moves it. stop/pause stay as no-op shims because the keyboard and
       scroll handlers above still call them. */
    function stop() {}
    function pause() {}

    /* Pin to the first slide. Slide widths are assigned after images and fonts
       settle, and any reflow before that can leave the track parked between
       slides, so re-assert position 0 across the load rather than once at init.
       Any reader input anywhere in the carousel (swipe, arrow, thumbnail)
       releases the pin immediately so it can never fight a real interaction. */
    var __host = t.closest('[data-bn="carousel"]') ||
                 t.closest('.bnc-group\\/carousel') || t.parentElement || t;
    function releasePin() { t.__bncUserMoved = true; }
    ['pointerdown', 'touchstart', 'keydown', 'wheel', 'click'].forEach(function (ev) {
      __host.addEventListener(ev, releasePin, { passive: true });
    });
    function pinFirst() {
      if (t.__bncUserMoved) return;
      t.__bncProgrammatic = true;
      t.scrollLeft = 0;
      t.scrollTop = 0;
      setTimeout(function () { t.__bncProgrammatic = false; }, 60);
    }
    pinFirst();
    [120, 400, 1000, 2000].forEach(function (ms) { setTimeout(pinFirst, ms); });
    window.addEventListener('load', pinFirst);
  }

  /* ---------------------------------------------------------------- *
   * Sticky ATC anchor bar: reveal on scroll, smooth-scroll to the
   * product module. Falls back to the href anchor with no JS.
   * ---------------------------------------------------------------- */
  /* Collapse an over-long section behind a reveal.
     The reviews block runs 7,663px on a 375px viewport - 36% of the whole page
     and roughly nine screens. Reviews are the strongest proof asset on the
     page, so the answer is not to cut them but to stop them acting as a wall:
     show enough to establish credibility, let anyone who wants more open it.
     Everything below it (FAQ, final CTA) becomes reachable as a result. */
  function initCollapse() {
    var CAP = window.innerWidth < 768 ? 1500 : 1300;
    $$('[data-bn-collapse]').forEach(function (sec) {
      if (sec.__bnCol) return;
      if (sec.scrollHeight <= CAP * 1.25) return;
      sec.__bnCol = true;
      sec.classList.add('bn-collapse');
      sec.style.setProperty('--bn-collapse-max', CAP + 'px');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bn-collapse__toggle';
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = sec.getAttribute('data-bn-collapse-label') || 'Show all reviews';
      sec.appendChild(btn);

      btn.addEventListener('click', function () {
        var open = sec.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open
          ? (sec.getAttribute('data-bn-collapse-less') || 'Show fewer reviews')
          : (sec.getAttribute('data-bn-collapse-label') || 'Show all reviews');
        if (!open) scrollToEl(sec);
      });
    });
  }

  /* Bootstrap independently of init(). Relying on ordering inside init() meant
     a throw in any earlier step silently skipped this, and the collapse never
     applied. Runs on DOM ready, again on load (images settle and change the
     measured height), and is idempotent via the __bnCol flag. */
  function bootCollapse() {
    try { initCollapse(); } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootCollapse, { once: true });
  } else {
    bootCollapse();
  }
  window.addEventListener('load', function () {
    bootCollapse();
    setTimeout(bootCollapse, 600);
  }, { once: true });

  /* Pin the gallery column beside the long info column. Walk up from the
     gallery to the child of the multi-column grid that actually owns that
     column, and only pin when the sibling column is meaningfully taller -
     otherwise sticky does nothing and only risks surprises. */
  function initStickyGallery() {
    if (window.innerWidth < 1024) return;
    var gal = $('[data-bn="product-images"]') || $('[class*="bnc-gallery-"]') || $('.bn-pm__gallery');
    if (!gal || gal.__bnSticky) return;
    var el = gal, col = null;
    for (var i = 0; i < 10 && el && el.parentElement; i++) {
      var par = el.parentElement;
      var pc = getComputedStyle(par);
      var tracks = (pc.gridTemplateColumns || '').trim().split(/\s+(?![^(]*\))/).length;
      if (pc.display === 'grid' && tracks >= 2) { col = el; break; }
      el = par;
    }
    if (!col) return;
    /* Measure AFTER pinning, not before. A grid child defaults to
       `align-self: stretch`, so its height already equals the row and any
       ratio test against it always fails - which is exactly why the first
       attempt never applied. Apply, measure, and revert if there is no gain. */
    var row = col.parentElement.getBoundingClientRect().height;
    // A clipping ancestor would confine sticky to its own box.
    var a = col.parentElement, blocked = false;
    while (a && a !== document.body) {
      var c = getComputedStyle(a);
      if (c.overflowY !== 'visible' && c.overflowY !== 'clip') { blocked = true; break; }
      a = a.parentElement;
    }
    if (blocked) return;
    col.classList.add('bn-sticky-col');
    var own = col.getBoundingClientRect().height;
    if (own > row * 0.85) {                 // nothing to gain; leave it alone
      col.classList.remove('bn-sticky-col');
      return;
    }
    gal.__bnSticky = true;
  }

  /* Builder CTA buttons.
     The builder renders these as <button> with no href and no handler - its own
     runtime bound the click, reading the destination from its editor data. Some
     carry an `href` ATTRIBUTE on the <button>, which is invalid HTML that only
     that runtime honoured. With the runtime gone every one of them is dead:
     "START TRAINING", "GET MY PADDLE TRAINER" and "SHOP NOW" all did nothing.

     Honour an href when the markup carries one; otherwise send the reader to the
     product module on this page, which is what the sticky bar already does and
     what a landing page wants - keep them on the page, at the buy block.
     Never touch the real add-to-cart (type=submit / name=add). */
  /* Scroll to an element. Compute the offset rather than using
     `scrollIntoView`, so the sticky header does not cover the target. Smooth by
     default; honour a reduced-motion preference, and fall back to an instant
     jump on browsers without the options form of scrollTo, so the CTA always
     lands even if the animation cannot run. */
  function prefersReducedMotion() {
    return window.matchMedia &&
           window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  /* Animate the scroll frame by frame rather than handing `behavior:'smooth'`
     to the browser. Native smooth scrolling is silently a no-op in some
     engines and embedded views - measured here not moving the page at all -
     and a CTA that does nothing is far worse than one that jumps. A rAF tween
     lands in every engine and is verifiable. */
  var __bnScrollRAF = null;
  /* Where a CTA should land. On a narrow screen the product module leads with
     the gallery, so landing on the module's top pushes the price roughly 650px
     down - off the bottom of a phone. Land on the price block instead, with
     enough headroom above it to keep the title and rating in frame. */
  /* Where a CTA should land. The reader needs the proof and the product name in
     frame when they arrive - rating, review count, then title - not the price
     row with everything above it already scrolled off. Target the topmost of
     those elements and clear only the sticky header, rather than aiming at the
     price and reserving headroom for the button group below it. */
  /* A candidate inside a position:fixed ancestor is page chrome - the sticky
     ATC bar carries a product title and a rating too. A fixed element's
     viewport top is constant, so it reads as "topmost" at every scroll
     position and wins the comparison, and a scroll toward it can never
     arrive: measured on the control page at 1440, the settle loop chased the
     bottom bar's title at +766px a tick until its hard stop, 5,000px past the
     product module. Fixed ancestry disqualifies; sticky ancestry stays
     eligible (the variant gallery pins) and is resolved by bnScrollAnchor. */
  function bnInFixed(el) {
    for (var n = el; n && n !== document.body; n = n.parentElement) {
      if (getComputedStyle(n).position === 'fixed') return true;
    }
    return false;
  }

  function buyHeaderTop() {
    var sels = [
      '.bn-pm__rating', '.bs-rating-wrap', '[data-bn="product-rating"]',
      '.bn-pm__title', '[data-bn="product-title"]'
    ];
    var best = null;
    for (var i = 0; i < sels.length; i++) {
      var cands = $$(sels[i]);
      for (var j = 0; j < cands.length; j++) {
        var c = cands[j];
        if (!c.getClientRects().length) continue;              // hidden at this breakpoint
        if (bnInFixed(c)) continue;
        if (!c.closest('#bn-buy, .bn-pm, [data-bn="product"], form[action*="/cart/add"]') &&
            !c.closest('[class*="bnc-product"], [class*="product-images"]')) continue;
        var top = c.getBoundingClientRect().top + window.pageYOffset;
        if (best === null || top < best.top) best = { el: c, top: top };
      }
    }
    return best ? best.el : null;
  }

  /* Height of anything pinned to the top, so the target is not hidden under it. */
  function stickyHeaderOffset() {
    var h = 0;
    $$('header, .site-header, [class*="sticky"], [data-bn="header"]').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      var r = el.getBoundingClientRect();
      if (r.top > 4 || r.height < 8 || r.height > 200) return;  // only top-pinned bars
      if (r.height > h) h = r.height;
    });
    return Math.round(h) + 12;                                   // small breathing gap
  }

  /* Van, 2026-08-31: a CTA should land like arriving on a PDP - the product
     IMAGE first, then rating and title. Aiming at the rating put the gallery
     off-screen above the fold, so the buyer arrived at "a bunch of text".
     The gallery sits above the rating in the module, so prefer it when it is
     there. `.bn-gal` is only ever applied inside the variant's product module,
     so the control page keeps its existing target. */
  function buyGalleryTop() {
    var sels = ['.bn-gal', '.bn-gal__main', '.bn-pm__gallery', '[id*="bnc-carousel-bnc-gallery"]'];
    for (var i = 0; i < sels.length; i++) {
      var c = $(sels[i]);
      if (c && c.getClientRects().length && !bnInFixed(c)) return c;
    }
    return null;
  }

  function buyTargetFor() {
    var gal = buyGalleryTop();
    var head = buyHeaderTop();
    /* Whichever sits higher on the page is the top of the buy frame. */
    if (gal && head) {
      var gt = gal.getBoundingClientRect().top;
      var ht = head.getBoundingClientRect().top;
      return { el: gt <= ht ? gal : head, offset: stickyHeaderOffset() };
    }
    if (gal) return { el: gal, offset: stickyHeaderOffset() };
    if (head) return { el: head, offset: stickyHeaderOffset() };
    var el = $('#bn-buy') || $('.bn-pm') || $('[data-bn="product"]');
    return el ? { el: el, offset: stickyHeaderOffset() } : null;
  }

  /* A scroll destination must be a DOCUMENT coordinate. When the element sits
     inside a position:sticky ancestor, its viewport rect follows the scroll
     once pinned, so any "scroll until the element is at the offset" logic
     chases a target that moves with each correction - measured on the control
     page at 1440: the loop drove 4,300px past the product module and parked at
     the footer. Anchor on the sticky ancestor's static parent instead; its rect
     is scroll-independent, and landing there is the point where the sticky
     column pins, which is exactly where the pinned gallery renders. */
  function bnScrollAnchor(el) {
    var n = el;
    while (n && n !== document.body) {
      if (getComputedStyle(n).position === 'sticky') return n.parentElement || el;
      n = n.parentElement;
    }
    return el;
  }

  function scrollToEl(el, offset) {
    if (!el) return;
    el = bnScrollAnchor(el);
    if (offset === undefined) offset = 90;
    /* The header offset has to be re-derived while scrolling, not captured at
       the click.

       Impulse's header is `position: relative` at the top of the page and only
       becomes `fixed` once the reader scrolls down. stickyHeaderOffset()
       therefore measures nothing at scroll 0 and returns its bare 12px gap; by
       the time the scroll lands, the header is fixed and 59px tall and covers
       the top of whatever we aimed at. Measured on the control homepage: every
       CTA landed with the gallery at 12px, 47px of it behind the header, while
       the same code on the variant landed clear at 60px - which is why the CTAs
       looked inconsistent between the two pages.

       Take whichever is larger, so the value only ever grows as the header
       pins, and the settle loop corrects to it. */
    function effOffset() {
      var s = stickyHeaderOffset();
      return s > offset ? s : offset;
    }
    var start = window.pageYOffset;
    var top = el.getBoundingClientRect().top + start - offset;
    if (top < 0) top = 0;
    if (__bnScrollRAF) cancelAnimationFrame(__bnScrollRAF);
    if (prefersReducedMotion() || !window.requestAnimationFrame) {
      window.scrollTo(0, top);
      setTimeout(function () {
        var want = el.getBoundingClientRect().top + window.pageYOffset - effOffset();
        if (want < 0) want = 0;
        if (Math.abs(want - window.pageYOffset) > 12) window.scrollTo(0, want);
      }, 400);
      return;
    }
    /* The CSS sets scroll-behavior:smooth for plain anchor links. Left on, it
       would animate every frame of this tween against itself. */
    var root = document.documentElement;
    var prev = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    var dist = top - start;
    var dur = Math.min(700, Math.max(240, Math.abs(dist) * 0.5));
    var t0 = null, started = false, guard = null;
    function finish() {
      if (guard) { clearTimeout(guard); guard = null; }
      __bnScrollRAF = null;
      root.style.scrollBehavior = prev;
      settle();                       // corrections start only once the tween is done
    }
    function step(ts) {
      started = true;
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var e = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      window.scrollTo(0, Math.round(start + dist * e));
      if (p < 1) { __bnScrollRAF = requestAnimationFrame(step); }
      else { finish(); }
    }
    /* A backgrounded or throttled tab never runs rAF, which would leave the CTA
       doing nothing at all. If no frame has arrived, jump straight to the
       target: arriving without the animation beats not arriving. */
    guard = setTimeout(function () {
      if (started) return;
      if (__bnScrollRAF) cancelAnimationFrame(__bnScrollRAF);
      window.scrollTo(0, top);
      finish();
    }, 300);
    __bnScrollRAF = requestAnimationFrame(step);

    /* Re-assert once the page settles. Media above the module loads after the
       jump and moves the target: measured on the variant, the rating sat at
       docY 4474 when the CTA was clicked and 4796 by the time the scroll landed
       - the module grew ~322px mid-flight and the reader arrived that far short.

       These corrections MUST run after the tween finishes, not on a timer from
       the click. They were previously scheduled at 260ms and 700ms while the
       tween itself runs for up to 700ms, so the first was overwritten by the
       still-animating tween and the second raced its final frame. A correction
       that fights the animation it is correcting never lands. */
    var interrupted = false;
    function markInterrupted() { interrupted = true; }
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, markInterrupted, { passive: true, once: true });
    });
    function settle() {
      /* Correct until the target HOLDS STILL, on a cadence with a hard stop.

         Four corrections on fixed timers lost this race: sections above the
         product module carry lazy media with no reserved height, so the
         document keeps growing after the last timer fires and the target
         drifts back down. Measured on the control page at 1440 with cold
         media: landed 1550px short at 1.6s, still 600px short at 3.4s -
         after every fixed correction had already fired. That is the
         "CTA takes you to the section above the buy block" report.

         The loop recomputes from the element each tick, so it tracks the
         target through every late layout shift; it only writes when drifted,
         declares arrival after three consecutive on-target ticks, and the
         reader taking over (wheel / touch / key) still cancels it. */
      var tries = 0, stable = 0, lastWrite = null;
      var iv = setInterval(function () {
        if (interrupted || __bnScrollRAF) { clearInterval(iv); return; }
        var elTop = el.getBoundingClientRect().top;
        /* Viewport-riding detector. After a genuine correction, a target in
           the document moves opposite the scroll by the same amount; a target
           that moved WITH the scroll (a fixed or sticky box that slipped the
           candidate filters) barely moves at all, and chasing it walks the
           page to its hard stop. Late-loading content is unaffected: it
           shifts the target's document position, and the next measurement
           still shows the counter-movement. */
        if (lastWrite) {
          var dScroll = window.pageYOffset - lastWrite.scrollY;
          var dEl = elTop - lastWrite.elTop;
          if (Math.abs(dScroll) > 40 && Math.abs(dEl) < Math.abs(dScroll) / 2) {
            clearInterval(iv); return;
          }
          lastWrite = null;
        }
        var want = elTop + window.pageYOffset - effOffset();
        if (want < 0) want = 0;
        if (Math.abs(want - window.pageYOffset) < 12) {
          if (++stable >= 3) clearInterval(iv);
        } else {
          stable = 0;
          lastWrite = { scrollY: window.pageYOffset, elTop: elTop };
          var prevB = document.documentElement.style.scrollBehavior;
          document.documentElement.style.scrollBehavior = 'auto';
          window.scrollTo(0, want);
          document.documentElement.style.scrollBehavior = prevB;
        }
        if (++tries > 32) clearInterval(iv);
      }, 250);
    }
  }

  function initCtaButtons() {
    // Resolved per click, not once at init: the right target depends on the
    // viewport, which can change after load (rotation, resize).
    $$('button.bnc-button-base, a.bnc-button-base').forEach(function (b) {
      if (b.__bnCta) return;
      var type = (b.getAttribute('type') || '').toLowerCase();
      if (type === 'submit' || b.getAttribute('name') === 'add') return;  // ATC
      if (b.closest('.bn-satc')) return;                                  // sticky bar owns its own
      b.__bnCta = true;

      var href = b.getAttribute('href');
      /* Buy-intent CTAs belong to the buy block, whatever the builder wired
         them to. On the control page these carry builder element anchors
         (`#el-gGMLpNzUPH`) that resolve to an arbitrary element part-way down
         the page, which is the "takes you to the wrong place" report. Match on
         intent rather than on href, and leave every other in-page anchor
         (FAQ jumps, section links) exactly as authored. */
      var BUY_INTENT = /\b(shop|buy|order|start training|get (my|the|yours|it))\b/i;
      var isBuyCta = BUY_INTENT.test((b.innerText || b.textContent || '').replace(/\s+/g, ' ').trim());

      b.addEventListener('click', function (e) {
        if (isBuyCta) {
          var bbt = buyTargetFor();
          if (bbt) { e.preventDefault(); scrollToEl(bbt.el, bbt.offset); return; }
        }
        /* An in-page anchor scrolls, it does not navigate. Handled here rather
           than left to the browser so the sticky-header offset is applied and
           the behaviour is identical on <button href> and <a href>. */
        if (href && href.charAt(0) === '#' && href.length > 1) {
          var anchor = document.getElementById(href.slice(1)) ||
                       document.querySelector(href);
          if (anchor) { e.preventDefault(); scrollToEl(anchor); return; }
        }
        /* A CTA pointing at the product page, on a page that already carries
           the buy block, should keep the reader here and scroll to it rather
           than reloading into the PDP. The href stays in the markup so the link
           still works if this script never runs. */
        var bt = buyTargetFor();
        if (href && bt && href.indexOf('/products/') > -1) {
          e.preventDefault();
          scrollToEl(bt.el, bt.offset);
          return;
        }
        if (href) {
          // A real URL with nothing to scroll to: navigate.
          if (b.tagName === 'A') return;
          e.preventDefault();
          window.location.href = href;
          return;
        }
        if (bt) {
          e.preventDefault();
          scrollToEl(bt.el, bt.offset);
        }
      });
      if (!b.getAttribute('role')) b.setAttribute('role', 'button');
    });
  }

  function initStickyATC() {
    var bar = $('[data-bn-sticky-atc]');
    if (!bar || bar.__bnc) return; bar.__bnc = true;
    bar.removeAttribute('hidden');

    /* Reparent to <body>. A compiled ancestor carries a transform, which makes
       it the containing block for this fixed bar, so left/right:0 resolved
       against that ancestor and the bar laid out far wider than the viewport. */
    if (bar.parentElement !== document.body) document.body.appendChild(bar);

    /* Clamp the bar to the layout viewport, and keep it clamped.

       `left:0; right:0` resolves against the initial containing block, which is
       not always the layout viewport - measured 1500px wide inside a 375px
       layout viewport. An earlier version of this pinned a pixel width once at
       load and refreshed only on a debounced resize, which left a stale width
       after an orientation change; a ResizeObserver on the document element
       tracks every size change instead, including orientation.

       Also lift the bar above Shopify's theme preview bar when one is present.
       That bar is 68px pinned to the bottom and covers this one exactly, which
       is why it looks missing while QAing through a preview link. It never
       exists for customers, so this only affects preview sessions. */
    /* The bar is sized entirely in CSS: `position:fixed; left:0; right:0`,
       the same pattern stock Impulse uses for `.site-header--stuck`. An earlier
       version measured `documentElement.clientWidth` and froze it onto the bar
       as `width:<n>px !important` with `right:auto`. That replaced a self-
       maintaining constraint with a snapshot, and a fixed element is NOT
       clipped by `overflow-x:clip/hidden` on html/body - so any moment the
       measurement read wide (first paint, URL-bar collapse, an app mounting)
       locked in permanent horizontal scroll that no containment rule could
       undo. Left/right anchoring cannot go stale. Do not reintroduce a
       JS-measured width here. */

    var target = $('#bn-buy') || $('.bn-pm') || $('[data-bn="product"]') || $('form[action*="/cart/add"]');
    var cta = $('[data-bn-scroll-to]', bar);
    if (cta) {
      cta.addEventListener('click', function (e) {
        var bt = buyTargetFor();
        if (!bt && !target) return;
        e.preventDefault();
        if (bt) scrollToEl(bt.el, bt.offset); else scrollToEl(target);
      });
    }

    // Hide once the product module itself is on screen — the bar exists to get
    // the reader there, so it is noise once they have arrived.
    var atTarget = false;
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { atTarget = en.isIntersecting; sync(); });
      }, { threshold: 0.2 }).observe(target);
    }
    /* The stylesheet owns the visible state: the bar is shown by default and
       `.is-at-target` slides it away. Toggling any other class name leaves the
       bar permanently pinned, because nothing styles that name - which is what
       `is-visible` was doing here. Drive the class the CSS actually defines. */
    function sync() {
      bar.classList.toggle('is-at-target', atTarget);
    }
    sync();
  }

  function init() {
    $$('[data-bn-role]').forEach(function (el) {
      var fn = ROLES[el.getAttribute('data-bn-role')];
      if (fn) { try { fn(el); } catch (e) {} }
    });
    initLazy();
    initGalleryAutoplay();
    initVideoProbe();
    setTimeout(initGalleryAutoplay, 1500);
    initVideoVisibility();   /* unconditional: initLazy early-returns when a page has no [data-src] media, and natively-autoplaying videos still need gating */
    $$('.gem-slider, .gem-slider-wrapper').forEach(initSliderTrack);
    initStickyATC();
    initCtaButtons();
    initSequenceFix();
    initReviewCounts();
    initOverflowProbe();
    initSchemaDates();
    initSingleSubmitATC();
    initUpsellCartSync();
    setTimeout(initReviewCounts, 900);
    initPriceBlock();
    initUpsell();
    initUpsellPrice();
    setTimeout(initUpsell, 700);
    setTimeout(initPriceBlock, 600);
    initStickyGallery();
    window.addEventListener('resize', function () { initStickyGallery(); });
    initCollapse();
    window.addEventListener('resize', function () { initCollapse(); });
    initMarqueeTracks();
    initPressMarquee();
    initArrowVisibility();
    setTimeout(initArrowVisibility, 800);
    window.addEventListener('resize', function () { initArrowVisibility(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  window.addEventListener('load', function () {
    init();
    setTimeout(loadRemaining, 1200);
    setTimeout(loadRemaining, 4000);
  }, { once: true });
})();
